/* Zephyrian — Claude Design homepage runtime.
   Vanilla port of the Claude Design (dc.html) component logic.
   Sections are initialized via [data-zph] roots; safe to load multiple times.
   (rev: any edit to this file also serves as a CDN cache-key bump — Shopify
   caches error responses per ?v= key, so a poisoned 504 needs a new version) */
(function () {
  'use strict';
  if (window.__ZPH_LOADED__) return;
  window.__ZPH_LOADED__ = true;

  var reduce = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };
  var ticks = []; // fns run on scroll/resize
  var lastY = 0, navState = { hidden: false, dark: false, scrolled: false };

  function readY() {
    return window.scrollY || (document.scrollingElement && document.scrollingElement.scrollTop) ||
      document.documentElement.scrollTop || document.body.scrollTop || 0;
  }
  function bezier(x1, y1, x2, y2) {
    var cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx;
    var cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by;
    var sampleX = function (t) { return ((ax * t + bx) * t + cx) * t; };
    var sampleY = function (t) { return ((ay * t + by) * t + cy) * t; };
    var dX = function (t) { return (3 * ax * t + 2 * bx) * t + cx; };
    var solveX = function (x) {
      var t = x, i;
      for (i = 0; i < 8; i++) { var xe = sampleX(t) - x; if (Math.abs(xe) < 1e-4) return t; var d = dX(t); if (Math.abs(d) < 1e-6) break; t -= xe / d; }
      var lo = 0, hi = 1; t = x;
      for (i = 0; i < 24; i++) { var s = sampleX(t); if (Math.abs(s - x) < 1e-4) break; if (x > s) lo = t; else hi = t; t = (lo + hi) / 2; }
      return t;
    };
    return function (x) { return x <= 0 ? 0 : (x >= 1 ? 1 : sampleY(solveX(x))); };
  }
  function fmtCount(el, v) {
    var dec = parseInt(el.dataset.countDecimals || '0', 10);
    var s = v.toFixed(dec);
    if (el.dataset.countComma === '1') { var p = s.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); s = p.join('.'); }
    return s + (el.dataset.countSuffix || '');
  }
  function runCount(section) {
    var els = section.querySelectorAll('.zph-count');
    if (!els.length) return;
    var fin = function () { els.forEach(function (el) { el.textContent = fmtCount(el, parseFloat(el.dataset.countTo)); }); };
    if (reduce()) { fin(); return; }
    var dur = 2200, startT = performance.now();
    var ease = function (t) { return t >= 1 ? 1 : 1 - Math.pow(1 - t, 7); };
    els.forEach(function (el) { el.textContent = fmtCount(el, 0); });
    var iv = setInterval(function () {
      var t = (performance.now() - startT) / dur; if (t > 1) t = 1;
      var e = ease(t);
      els.forEach(function (el) { el.textContent = fmtCount(el, parseFloat(el.dataset.countTo) * e); });
      if (t >= 1) { clearInterval(iv); fin(); }
    }, 16);
    setTimeout(function () { clearInterval(iv); fin(); }, dur + 800);
  }
  function runCountProportional(section) {
    var els = section.querySelectorAll('.zph-count');
    if (!els.length) return;
    var fin = function (el) { el.textContent = fmtCount(el, parseFloat(el.dataset.countTo)); };
    if (reduce()) { els.forEach(fin); return; }
    var ease = function (t) { return t >= 1 ? 1 : 1 - Math.pow(1 - t, 7); };
    var maxV = Math.max.apply(null, Array.prototype.map.call(els, function (el) { return parseFloat(el.dataset.countTo); }));
    var maxDur = 2300;
    els.forEach(function (el) {
      var to = parseFloat(el.dataset.countTo);
      var dur = Math.max(480, maxDur * (to / maxV));
      var startT = performance.now();
      el.textContent = fmtCount(el, 0);
      var iv = setInterval(function () {
        var t = (performance.now() - startT) / dur; if (t > 1) t = 1;
        el.textContent = fmtCount(el, to * ease(t));
        if (t >= 1) { clearInterval(iv); fin(el); }
      }, 16);
      setTimeout(function () { clearInterval(iv); fin(el); }, dur + 800);
    });
  }
  function lockScrollOff(doc, prev) {
    doc.style.overflow = prev.overflow || ''; doc.style.paddingRight = prev.padRight || '';
  }

  /* ---------- Header / nav ---------- */
  function initHeader(root) {
    var header = root.querySelector('[data-zph-nav]');
    if (!header) return;
    document.body.classList.add('zph-home');

    /* Top clearance for the fixed bar is a CSS rule keyed on :has() — see
       main#MainContent:not(:has(.zph-sec)) in zph-home.css. This is the fallback
       for a browser that doesn't support :has(), and it runs nowhere else. */
    try {
      if (!(window.CSS && CSS.supports && CSS.supports('selector(:has(*))'))) {
        var mainEl = document.getElementById('MainContent');
        if (mainEl && !mainEl.querySelector('.zph-sec') && !mainEl.querySelector('.zph-doc-page')) {
          mainEl.style.paddingTop = 'var(--zph-nav-h, 104px)';
        }
      }
    } catch (e) { }

    /* The bar is fixed, so a page that opens with ordinary content starts
       underneath it. Every zph-* page before the cart opened with a full-bleed
       hero that sits under the bar on purpose, so the number had never been
       needed -- publish it now, and keep it current through the promo bar's
       rotation, orientation changes and font swaps. CSS carries a fallback for
       the moment before this runs. */
    function publishNavHeight() {
      var h = Math.round(header.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty('--zph-nav-h', h + 'px');
    }
    publishNavHeight();
    window.addEventListener('resize', publishNavHeight);
    if (window.ResizeObserver) new ResizeObserver(publishNavHeight).observe(header);
    var promoEl = root.querySelector('[data-promo-msg]');
    var promos = [];
    try { promos = JSON.parse(root.querySelector('[data-promo-json]').textContent); } catch (e) { }
    var promoI = 0;
    if (promos.length > 1 && promoEl) {
      setInterval(function () {
        promoI = (promoI + 1) % (promos.length === 2 ? 3 : promos.length);
        var idx = promos.length === 2 ? [0, 0, 1][promoI] : promoI;
        promoEl.textContent = promos[idx];
      }, 3600);
    }
    // menu drawer
    var overlay = root.querySelector('.zph-menu-overlay');
    var menu = root.querySelector('.zph-menu');
    function setMenu(open) {
      if (overlay) overlay.classList.toggle('open', open);
      if (menu) menu.classList.toggle('open', open);
      /* closing the menu drops any "loading" mark on a row inside it */
      if (!open) document.dispatchEvent(new CustomEvent('zph:menu-closed'));
    }
    root.querySelectorAll('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { setMenu(true); }); });
    root.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });

    /* ---- "your tap landed, the page is coming" ----
       Every link in this menu leaves the page, and a navigation shows nothing
       until the next paint. On a slow connection that reads as a dead control
       and the shopper taps again. Mark the chosen row instead. */
    if (menu) {
      var goingTimer = null;
      function clearGoing() {
        if (goingTimer) { clearTimeout(goingTimer); goingTimer = null; }
        menu.removeAttribute('data-going');
        menu.querySelectorAll('.zph-going').forEach(function (el) { el.classList.remove('zph-going'); });
      }
      /* Material's touch ripple: a circle out of the point actually touched,
         grown just far enough to reach the furthest corner, fading as it goes.
         Sized here rather than in CSS because only this knows where the finger
         landed. Keyboard activation reports no coordinates, so it starts from
         the middle. */
      function ripple(el, e) {
        if (reduce()) return;
        var r = el.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var x = e.clientX ? e.clientX - r.left : r.width / 2;
        var y = e.clientY ? e.clientY - r.top : r.height / 2;
        var far = Math.max(
          Math.sqrt(x * x + y * y),
          Math.sqrt((r.width - x) * (r.width - x) + y * y),
          Math.sqrt(x * x + (r.height - y) * (r.height - y)),
          Math.sqrt((r.width - x) * (r.width - x) + (r.height - y) * (r.height - y))
        );
        /* a touch of overshoot: sized to the exact corner distance the circle
           only just grazes the corners, and antialiasing leaves a sliver of
           un-covered row at each one */
        far = far * 1.06;
        var s = document.createElement('span');
        s.className = 'zph-ripple';
        s.style.width = s.style.height = (far * 2) + 'px';
        s.style.left = (x - far) + 'px';
        s.style.top = (y - far) + 'px';
        el.appendChild(s);
        var drop = function () { if (s.parentNode) s.parentNode.removeChild(s); };
        s.addEventListener('animationend', drop);
        setTimeout(drop, 900); /* animationend does not fire if the tab is hidden */
      }

      menu.addEventListener('click', function (e) {
        var hit = e.target.closest ? e.target.closest('a[href],button') : null;
        /* everything in the menu ripples, navigating or not */
        if (hit && menu.contains(hit)) ripple(hit, e);
        var a = e.target.closest ? e.target.closest('a[href]') : null;
        if (!a || !menu.contains(a)) return;
        /* opens a panel rather than navigating -- the cart icon is both a link
           and a drawer trigger, and a state that never resolves is worse than
           no state at all */
        if (a.hasAttribute('data-cart-open') || a.hasAttribute('data-menu-close')) return;
        if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        if (a.target && a.target !== '_self') return;
        var href = a.getAttribute('href') || '';
        if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(href)) return;
        /* a link to the page we are already on paints nothing to wait for */
        try {
          var dest = new URL(a.href, window.location.href);
          if (dest.origin === window.location.origin && dest.pathname === window.location.pathname) return;
        } catch (err) { }
        clearGoing();
        a.classList.add('zph-going');
        menu.setAttribute('data-going', '');
        /* if the navigation never happens -- blocked, offline, cancelled --
           hand the menu back rather than leaving it dimmed for good */
        goingTimer = setTimeout(clearGoing, 10000);
      });
      /* Back out of the destination and Safari restores this page from bfcache
         exactly as it was, dimmed row and all. pageshow fires either way. */
      window.addEventListener('pageshow', clearGoing);
      document.addEventListener('zph:menu-closed', clearGoing);
    }
    if (overlay) overlay.addEventListener('click', function () { setMenu(false); });

    /* WHAT COLOUR IS ACTUALLY BEHIND THE BAR?

       This used to ask a different question: "does any element carrying
       [data-nav-dark] overlap the nav band?" That is opt-in, so the bar only
       ever knew about the twelve sections somebody had remembered to tag. Every
       other dark section left it in light mode — measured on /pages/reviews,
       the bar sat light over five separate stretches of near-black purple.

       So it now measures instead of asking. Five points are sampled across the
       bar's own centre line; at each one the paint stack is walked for the
       first element that actually covers, and its sRGB relative luminance is
       taken. Nothing has to declare anything, and a new section is handled the
       day it is added.

       Two things the walk has to get right:

       - App overlays. Scratch-card and rewards apps mount full-viewport layers
         at z-index 2147483647. elementFromPoint hands back that layer, which
         belongs to no section and reads transparent, so anything outside a
         .shopify-section is stepped over.

       - Transparent elements. A hit is usually a gradient veil or a wrapper
         with no background of its own, so from each hit we walk UP until a
         background-colour that actually covers (alpha >= 0.5) is found. That
         is what makes video and image backgrounds work without a hint: the
         hero's <video> resolves to its section's deep purple, and the sky
         hero's cloud plates resolve to the stage's blue.

       [data-nav-dark] survives only as a hint for the one case measurement
       cannot see — a dark photograph sitting on a light background — and only
       when the hit is media. It is no longer a rect test, so the sky hero's
       full-height wrapper can no longer hold the bar dark long after the next
       section has ridden up over it. */
    function chan(v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
    function relLum(r, g, b) { return 0.2126 * chan(r) + 0.7152 * chan(g) + 0.0722 * chan(b); }

    /* first ancestor (starting at el) whose background actually covers */
    function coveringLum(el) {
      for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
        var cs;
        try { cs = getComputedStyle(n); } catch (e) { return null; }
        var m = (cs.backgroundColor || '').match(/[\d.]+/g);
        if (m && m.length >= 3) {
          var a = m.length > 3 ? parseFloat(m[3]) : 1;
          if (a >= 0.5) return relLum(+m[0], +m[1], +m[2]);
        }
        if (n.tagName === 'HTML') break;
      }
      return null;
    }

    function isMedia(el) {
      if (el.tagName === 'VIDEO' || el.tagName === 'IMG' || el.tagName === 'CANVAS') return true;
      var cs; try { cs = getComputedStyle(el); } catch (e) { return false; }
      var bi = cs.backgroundImage;
      return !!(bi && bi !== 'none' && bi.indexOf('url(') === 0);
    }

    /* null when nothing conclusive is under the point */
    function lumAt(x, y) {
      var stack;
      try { stack = document.elementsFromPoint(x, y); } catch (e) { return null; }
      for (var i = 0; i < stack.length; i++) {
        var el = stack[i];
        if (!el || !el.closest) continue;
        if (el.closest('[data-zph-nav]')) continue;
        if (!el.closest('.shopify-section')) continue;
        if (isMedia(el) && el.closest('[data-nav-dark]')) return 0;
        var l = coveringLum(el);
        if (l !== null) return l;
      }
      return null;
    }

    /* Sampling is time-throttled rather than run per frame. Five hit tests plus
       their ancestor walks is real work, and the colour swap is a .3s CSS
       transition, so re-reading more often than ~12x a second buys nothing
       anyone can see. */
    var lumLast = 0, lumVal = null;
    function bgLum(now) {
      if (now - lumLast < 80 && lumVal !== null) return lumVal;
      lumLast = now;
      var bar = header.querySelector('.zph-navbar') || header;
      var br = bar.getBoundingClientRect();
      var sy = Math.round(br.top + br.height / 2);
      if (sy < 1) sy = 1;
      var w = window.innerWidth, sum = 0, n = 0;
      var xs = [0.08, 0.3, 0.5, 0.7, 0.92];
      for (var i = 0; i < xs.length; i++) {
        var l = lumAt(Math.min(w - 2, Math.max(1, Math.round(w * xs[i]))), sy);
        if (l !== null) { sum += l; n++; }
      }
      lumVal = n ? sum / n : null;
      return lumVal;
    }

    lastY = readY();
    ticks.push(function () {
      var y = readY();
      var last = lastY; lastY = y;
      var hidden = navState.hidden;
      if (y < 90) hidden = false;
      else if (y < last - 3) hidden = false;
      else if (y > last + 6 && y > 150) hidden = true;
      navState.hidden = hidden;
      var scrolled = y > 30;
      /* Hysteresis, not a single threshold. A bar drifting across a gradient
         would otherwise flip on every frame it crossed 0.5. Dark is entered
         below 0.5 and left above 0.62; inside that band whatever it already was
         stands. When nothing conclusive is under the bar the last state stands
         too — guessing "light" there is what once put purple links on the
         purple hero. */
      var lum = bgLum(performance.now ? performance.now() : Date.now());
      var ndark = navState.dark;
      if (lum !== null) {
        if (ndark && lum > 0.62) ndark = false;
        else if (!ndark && lum < 0.5) ndark = true;
      }
      navState.dark = ndark;
      var cls = 'zph-header-fixed' +
        (hidden ? ' zph-nav--hidden' : '') +
        (scrolled ? (' zph-nav--scrolled' + (ndark ? ' zph-nav--dark' : '')) : (' zph-nav--top' + (ndark ? ' zph-nav--dark' : '')));
      /* This wrote className on every tick, and the value only actually changes at
         a handful of scroll positions. Writing the same string still dirties the
         element's style and invalidates its subtree, so the compare is much
         cheaper than the write it avoids. */
      if (cls !== navState.cls) { navState.cls = cls; header.className = cls; }
    });
  }

  /* ---------- Hero ---------- */
  /* ---------- Hero background video ----------
     The hero used to point straight at Mux's static capped-1080p.mp4, so every
     visitor downloaded one 11.4MB file regardless of screen size or connection.
     Mux publishes an HLS ladder for the same playback ID; this attaches it so the
     player picks a rung. Safari/iOS play HLS natively, everything else gets
     hls.js loaded on demand. Any failure at any step falls back to the original
     MP4, so the worst case is exactly the old behaviour. */
  function initHeroVideo(root) {
    var v = root.querySelector('[data-hero-video]');
    if (!v || v.dataset.zphHeroInit) return;
    v.dataset.zphHeroInit = '1';

    var hlsUrl = v.getAttribute('data-hls');
    var mp4Url = v.getAttribute('data-mp4');
    var libUrl = v.getAttribute('data-hlsjs');
    var settled = false;

    /* FLOOR THE LADDER IN THE MANIFEST, NOT IN THE PLAYER.

       Reported as "the hero is blurry until the flamingo scene". Measured on a
       1920px desktop at DPR2 — a 3840x1620 element — the decoded size ran
       480x270 for the first eight seconds, reached 1080p at twelve, 2160p only
       at twenty-one, and dropped straight back to 480x270 when the clip looped.
       Every player opens on the bottom rung because none has measured any
       bandwidth yet, then climbs one rung per segment.

       Three attempts to fix this through hls.js config did nothing at all, for
       a reason worth recording: Chromium returns "maybe" from
       canPlayType('application/vnd.apple.mpegurl'), which is truthy, so the
       native branch below wins and hls.js is never loaded. The config was dead
       code. It would also never have helped iOS, where hls.js cannot run.

       Mux honours min_resolution on the playback URL and drops the low rungs
       from the manifest itself, so there is nothing left to open low on — one
       fix for the native player, hls.js and iOS alike.

       The floor is chosen from what the element actually has to fill in device
       pixels, and is deliberately set at about half of that: enough that the
       worst frame anyone sees is the same upscale the old static MP4 gave, with
       ABR still free to climb above it. Desktop floors at 1080p, which is
       exactly what the 11.4MB MP4 used to serve, so nobody sees worse than
       before while most see better. Phones floor at 480p rather than 720p —
       854x480 across a 1170px screen is a soft-but-fine 1.4x upscale, where
       720p would triple the mobile bytes this whole pass existed to remove.

       A CEILING matters as much as the floor, and leaving it off was a real
       regression: with capLevelToPlayerSize disabled nothing stopped ABR
       climbing past what the screen can show, so a 1170px phone ran up to
       2560x1440 and pulled 11.7MB in eighteen seconds, an iPad 20.4MB. Every
       rung it climbs through is fetched again, so the climb itself is most of
       the waste. Capped at the rung that actually covers the element, both the
       redundant climbing and the pointless resolution disappear. */
    if (hlsUrl && hlsUrl.indexOf('_resolution') === -1) {
      var px = Math.round((v.getBoundingClientRect().width || window.innerWidth || 1280) * (window.devicePixelRatio || 1));
      var band = px >= 2400 ? ['1080p', '2160p']
               : px >= 1400 ? ['720p', '1080p']
               : px >= 900 ? ['480p', '720p']
               : ['', '480p'];
      var q = [];
      if (band[0]) q.push('min_resolution=' + band[0]);
      if (band[1]) q.push('max_resolution=' + band[1]);
      if (q.length) hlsUrl += (hlsUrl.indexOf('?') === -1 ? '?' : '&') + q.join('&');
    }

    function play() {
      var p = v.play();
      if (p && p.catch) p.catch(function () { });
    }
    function useMp4() {
      if (settled || !mp4Url) return;
      settled = true;
      v.src = mp4Url;
      v.load();
      play();
    }

    if (!hlsUrl) { useMp4(); return; }

    /* Safari, iOS, and any UA with native HLS — no library required */
    if (v.canPlayType('application/vnd.apple.mpegurl')) {
      settled = true;
      v.src = hlsUrl;
      play();
      /* if the manifest can't be fetched, drop back to the MP4 */
      v.addEventListener('error', function () { settled = false; useMp4(); }, { once: true });
      return;
    }

    if (!libUrl) { useMp4(); return; }

    function attach() {
      if (settled) return;
      if (!window.Hls || !window.Hls.isSupported()) { useMp4(); return; }
      try {
        /* capLevelToPlayerSize measures the element in CSS pixels and ignores
           devicePixelRatio, so on a 390px-wide phone at 3x it picked a ~400px
           rendition and stretched it across 1170 device pixels. Off.

           But turning it off only removed the ceiling; it did nothing about the
           floor, and the floor was the visible problem. startLevel:-1 hands the
           first fragment to ABR, ABR has measured no bandwidth yet, so it opens
           on rung 0 and climbs one rung per segment. Measured on a 1920px
           desktop at DPR2 — a 3840px-wide element — it ran 480x270 for the first
           eight seconds and did not reach 2160p until twenty-one seconds in,
           roughly two thirds of the way through the clip. Then the loop restarts
           and it drops to 480x270 again. abrEwmaDefaultEstimate did not prevent
           any of that; the comment that used to sit here claiming it did was
           wrong.

           So the opening rung is chosen from what the element actually has to
           fill, in device pixels, rather than guessed. ABR takes over once a few
           seconds are buffered, with a floor of roughly half the target so a
           loop restart cannot fall back to a thumbnail. Phones are unaffected in
           the direction that matters: 390px at 3x asks for 1170px and gets the
           720p rung, not the 2160p one. */
        var hls = new window.Hls({
          capLevelToPlayerSize: false,
          startLevel: -1,
          abrEwmaDefaultEstimate: 5000000
        });
        hls.on(window.Hls.Events.ERROR, function (_e, data) {
          /* only bail on unrecoverable errors — hls.js self-heals the rest */
          if (data && data.fatal) { try { hls.destroy(); } catch (e) { } settled = false; useMp4(); }
        });
        /* No start-level juggling here any more. The manifest itself is
           floored via min_resolution above, which works for this player and for
           the native one Chromium and iOS actually use — three rounds of config
           here were dead code, because canPlayType returns "maybe" on Chromium
           and the native branch returns before this ever runs. */
        hls.loadSource(hlsUrl);
        hls.attachMedia(v);
        hls.on(window.Hls.Events.MANIFEST_PARSED, play);
        settled = true;
      } catch (e) { useMp4(); }
    }

    if (window.Hls) { attach(); return; }
    var s = document.createElement('script');
    s.src = libUrl;
    s.async = true;
    s.onload = attach;
    s.onerror = useMp4;
    document.head.appendChild(s);
    /* don't let a hanging request leave the hero on a poster forever */
    setTimeout(function () { if (!settled) useMp4(); }, 4000);
  }

  function initHero(root) {
    initHeroVideo(root);
    var wordEl = root.querySelector('[data-hero-word]');
    if (!wordEl) return;
    var words = [];
    try { words = JSON.parse(root.querySelector('[data-hero-words]').textContent); } catch (e) { }
    var wrap = wordEl.parentElement; // .zph-introtext
    var i = 0, lastWipe = 0, wipeT = null;
    function wipe() {
      if (reduce()) return;
      var now = Date.now();
      if (lastWipe && now - lastWipe < 400) return;
      lastWipe = now;
      wrap.classList.remove('zph-anim'); void wrap.offsetWidth; wrap.classList.add('zph-anim');
      clearTimeout(wipeT);
      wipeT = setTimeout(function () { wrap.classList.remove('zph-anim'); }, 1550);
    }
    if (words.length > 1) {
      setInterval(function () { i = (i + 1) % words.length; wordEl.textContent = words[i]; wipe(); }, 4800);
    }
    setTimeout(wipe, 60);
  }

  /* ---------- Research quotes (Salty Face pattern: logos select quotes) ---------- */
  function initResearch(root) {
    var qEl = root.querySelector('[data-research-quote]');
    var aEl = root.querySelector('[data-research-attr]');
    if (!qEl) return;
    var data = [];
    try { data = JSON.parse(root.querySelector('[data-research-json]').textContent); } catch (e) { }
    var logos = Array.prototype.slice.call(root.querySelectorAll('[data-research-logo]'));
    /* the Nth logo pairs with the Nth quote block; rotation only covers
       quotes that have a logo so the highlight always has somewhere to sit */
    var n = logos.length ? Math.min(data.length, logos.length) : data.length;
    var i = 0, rqT = null, timer = null;
    function mark() {
      logos.forEach(function (b, k) { b.classList.toggle('on', k === i); });
    }
    function show(k, instant) {
      var swap = function () {
        i = k % n;
        qEl.textContent = '“' + data[i].q + '”';
        if (aEl) aEl.textContent = data[i].a;
        mark();
      };
      if (instant || reduce()) { swap(); return; }
      [qEl, aEl].forEach(function (el) { if (!el) return; el.classList.remove('zph-qin'); void el.offsetWidth; el.classList.add('zph-qout'); });
      clearTimeout(rqT);
      rqT = setTimeout(function () {
        swap();
        setTimeout(function () { [qEl, aEl].forEach(function (el) { if (!el) return; el.classList.remove('zph-qout'); void el.offsetWidth; el.classList.add('zph-qin'); }); }, 40);
      }, 520);
    }
    function arm() {
      if (timer) clearInterval(timer);
      if (n > 1) timer = setInterval(function () { show(i + 1); }, 6500);
    }
    logos.forEach(function (b, k) {
      b.addEventListener('click', function () { show(k); arm(); });
    });
    arm();
    var done = false;
    ticks.push(function () {
      if (done) return;
      var vh = window.innerHeight || 0;
      if (root.getBoundingClientRect().top < vh * 0.85) { done = true; runCount(root); }
    });
  }

  /* ---------- Numbers strip ---------- */
  function initNumbers(root) {
    if (!reduce()) root.querySelectorAll('.zph-count').forEach(function (el) { el.textContent = fmtCount(el, 0); });
    var done = false;
    ticks.push(function () {
      if (done) return;
      var vh = window.innerHeight || 0;
      if (root.getBoundingClientRect().top < vh * 0.85) { done = true; runCount(root); }
    });
  }

  /* ---------- Softgel delivery (astaxanthin loop) ---------- */
  /* The delivery section prints the same <video> twice — once in the mobile
     wrapper, once in the desktop one — and CSS reveals whichever fits. Both were
     downloading the 1.9MB loop, because a display:none <video> with preload=auto
     still fetches: 3.85MB for one visible clip. The <source> now carries data-src
     instead of src, and only the copy that is actually laid out gets wired up.
     Deliberately never torn down again: crossing the breakpoint mid-session is
     rare, and churning the buffer costs more than the second copy saves. */
  function initDeliveryVideo(root) {
    var vids = Array.prototype.slice.call(root.querySelectorAll('[data-pill-video]'));
    if (!vids.length) return;

    /* Which copy is live is decided by CSS display, so read that rather than
       offsetParent/getClientRects — those also report "hidden" for anything
       below the fold, which would leave BOTH copies unwired and the section
       silently video-less. Computed display is accurate off-screen. */
    function hidden(el) {
      for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
        if (getComputedStyle(n).display === 'none') return true;
      }
      return false;
    }
    function activate() {
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i];
        var srcEl = v.querySelector('source[data-src]');
        if (!srcEl || srcEl.getAttribute('src')) continue;   /* already wired */
        if (hidden(v)) continue;                             /* the other breakpoint's copy */
        srcEl.setAttribute('src', srcEl.getAttribute('data-src'));
        v.load();
        var p = v.play();
        if (p && p.catch) p.catch(function () { });
      }
    }

    /* below the fold, so don't compete with the hero — wire it up shortly before
       it can be seen, and fall back to wiring immediately where IO is missing */
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { io.disconnect(); activate(); break; }
        }
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else {
      activate();
    }
    window.addEventListener('resize', activate, { passive: true });
  }

  function initDelivery(root) {
    initDeliveryVideo(root);
    /* Slot-machine reel. The reel rolls strictly downward: the active step pops
       right and lights up, its neighbours hold the heading's left edge.

       One rAF tween drives ONE continuous position, and every visible quantity
       — row offset, the active row's rightward pop, per-step opacity, and the
       dashed arcs between the nodes — is derived from it each frame. That is
       what makes the arcs travel with the steps: they are rebuilt from live
       node positions rather than drawn as fixed art that only lines up at rest.
       The old code could not do this, so it faded the arcs out for the duration
       of the move and back in on landing; with the steps sliding past static
       arcs, the motion read as wrong rather than merely absent.

       Nothing runs between turns — the tween stops itself on landing, and the
       IntersectionObserver stops the turns entirely while the reel is offscreen. */
    var slot = root.querySelector('[data-dslot]');
    if (slot && !slot.dataset.zphSlotInit && !reduce()) {
      var sItems = [].slice.call(slot.querySelectorAll('[data-dslot-item]'));
      if (sItems.length > 1) {
        slot.dataset.zphSlotInit = '1';
        var rail = slot.querySelector('[data-drail]');
        var NS = 'http://www.w3.org/2000/svg';
        var NIT = sItems.length;
        var FADE = 0.32, DWELL = 4200, TRAVEL = 950, GAP = 6;
        /* How far out a step stays on the reel before it is fully gone. Held
           just inside the wrap boundary (NIT/2, where the index flips from the
           bottom of the reel to the top) so a step is always at zero opacity
           by the time it teleports — with only 3 steps those two points are
           otherwise close enough that the wrap is visible as a flicker. */
        var EDGE = Math.min(1.45, NIT / 2 - 0.05);
        var travelEase = bezier(0.62, 0.02, 0.16, 1);

        /* Read back off the element so the merchant's --dslot-* values and the
           640px breakpoint stay authoritative. Re-read on every turn and on
           resize: the old reel measured once and never again, so crossing the
           breakpoint left it drawing mobile spacing (60px pitch, 28px pop) at
           desktop width inside a box sized for 46px rows. */
        var geo = { row: 46, pop: 34, mid: 69, r: 14 };
        var measure = function () {
          var cs = getComputedStyle(slot);
          geo.row = parseFloat(cs.getPropertyValue('--dslot-row')) || 46;
          geo.pop = parseFloat(cs.getPropertyValue('--dslot-pop')) || 34;
          geo.r = (parseFloat(cs.getPropertyValue('--dnode')) || 28) / 2;
          geo.mid = slot.clientHeight / 2;
        };

        /* Signed distance from the active row, wrapped to the shorter way round. */
        var dOf = function (i, pos) {
          var d = (((i - pos) % NIT) + NIT) % NIT;
          return d > NIT / 2 ? d - NIT : d;
        };
        /* Both curves are cosine-shaped so they flatten out at each end — the
           step eases into and out of the active slot instead of arriving at a
           constant rate and stopping dead. */
        var bumpOf = function (a) { return a < 1 ? 0.5 * (1 + Math.cos(Math.PI * a)) : 0; };
        var alphaOf = function (a) {
          if (a <= 1) return FADE + (1 - FADE) * bumpOf(a);
          if (a >= EDGE) return 0;
          return FADE * 0.5 * (1 + Math.cos(Math.PI * (a - 1) / (EDGE - 1)));
        };
        /* Arcs stay at full strength between the three resident steps and only
           fade for one that is entering or leaving, so at rest they look exactly
           as they always have rather than inheriting a dim neighbour's opacity. */
        var presenceOf = function (a) {
          if (a <= 1) return 1;
          if (a >= EDGE) return 0;
          return 0.5 * (1 + Math.cos(Math.PI * (a - 1) / (EDGE - 1)));
        };

        var pool = [];
        var pathAt = function (k) {
          if (pool[k]) return pool[k];
          var p = document.createElementNS(NS, 'path');
          rail.appendChild(p);
          pool[k] = p;
          return p;
        };
        /* One dashed connector per adjacent pair, trimmed clear of both node
           circles. The end tangents are taken Catmull-Rom style from the
           neighbouring nodes, so consecutive arcs leave and arrive at matching
           angles and the whole chain reads as a single flowing line that bends
           as the pop moves down it. */
        var drawRail = function (nodes) {
          var k = 0;
          for (var j = 0; j < nodes.length - 1; j++) {
            var A = nodes[j], B = nodes[j + 1];
            var vx = B.x - A.x, vy = B.y - A.y;
            var L = Math.sqrt(vx * vx + vy * vy);
            var trim = geo.r + GAP;
            if (L <= trim * 2 + 4) continue;
            var P0 = nodes[j - 1] || { x: A.x - vx, y: A.y - vy };
            var P3 = nodes[j + 2] || { x: B.x + vx, y: B.y + vy };
            var ax = B.x - P0.x, ay = B.y - P0.y;
            var al = Math.sqrt(ax * ax + ay * ay) || 1; ax /= al; ay /= al;
            var bx = P3.x - A.x, by = P3.y - A.y;
            var bl = Math.sqrt(bx * bx + by * by) || 1; bx /= bl; by /= bl;
            var sx = A.x + ax * trim, sy = A.y + ay * trim;
            var ex = B.x - bx * trim, ey = B.y - by * trim;
            var hd = (L - trim * 2) * 0.42;
            var p = pathAt(k++);
            p.setAttribute('d', 'M' + sx.toFixed(1) + ' ' + sy.toFixed(1) +
              'C' + (sx + ax * hd).toFixed(1) + ' ' + (sy + ay * hd).toFixed(1) +
              ' ' + (ex - bx * hd).toFixed(1) + ' ' + (ey - by * hd).toFixed(1) +
              ' ' + ex.toFixed(1) + ' ' + ey.toFixed(1));
            p.style.opacity = Math.min(A.p, B.p).toFixed(3);
          }
          for (; k < pool.length; k++) pool[k].style.opacity = '0';
        };

        var render = function (pos) {
          var nodes = [];
          for (var i = 0; i < NIT; i++) {
            var d = dOf(i, pos), a = Math.abs(d);
            var bump = bumpOf(a);
            var x = geo.pop * bump, y = d * geo.row;
            var it = sItems[i];
            it.style.transform = 'translate(' + x.toFixed(2) + 'px, calc(-50% + ' + y.toFixed(2) + 'px))';
            it.style.opacity = alphaOf(a).toFixed(3);
            /* The node's emphasis rides the same curve as the pop, so it cannot
               drift out of sync with the row it belongs to. It is written as
               transform and opacity on promoted elements rather than through a
               custom property, because this reel animates INSIDE .zph-glass,
               whose backdrop-filter makes it a backdrop root: anything that
               paints in there forces the browser to re-sample and re-filter the
               backdrop — an SVG filter plus a blur — on that frame. The first
               version drove a --act custom property into box-shadow spread and
               background alpha, neither of which can be composited, so it
               repainted inside that root 60 times a second. */
            if (!it.__nd) { it.__nd = it.querySelector('.zph-dnode'); it.__hl = it.querySelector('[data-dhalo]'); }
            if (it.__nd) it.__nd.style.transform = 'scale(' + (1 + 0.06 * bump).toFixed(4) + ')';
            if (it.__hl) {
              it.__hl.style.opacity = bump.toFixed(3);
              it.__hl.style.transform = 'scale(' + (0.82 + 0.18 * bump).toFixed(4) + ')';
            }
            if (rail) nodes.push({ d: d, x: geo.r + x, y: geo.mid + y, p: presenceOf(a) });
          }
          if (!rail) return;
          nodes.sort(function (m, n) { return m.d - n.d; });
          drawRail(nodes);
        };

        var pos = 0, target = 0, from = 0, t0 = 0, raf = 0, sTimer = null;
        var frame = function (now) {
          var t = (now - t0) / TRAVEL;
          if (t >= 1) { pos = target; render(pos); raf = 0; return; }
          pos = from + (target - from) * travelEase(t);
          render(pos);
          raf = requestAnimationFrame(frame);
        };
        var advance = function () {
          measure();
          from = pos; target += 1; t0 = performance.now();
          if (!raf) raf = requestAnimationFrame(frame);
        };
        slot.__advance = advance;

        measure();
        render(0);
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) { if (!sTimer) sTimer = setInterval(advance, DWELL); }
            else if (sTimer) {
              clearInterval(sTimer); sTimer = null;
              /* park settled rather than mid-slide, so it is never rejoined halfway */
              if (raf) { cancelAnimationFrame(raf); raf = 0; pos = target; render(pos); }
            }
          });
        }, { threshold: 0.35 }).observe(slot);

        var rzT = 0;
        window.addEventListener('resize', function () {
          clearTimeout(rzT);
          rzT = setTimeout(function () { measure(); render(pos); }, 120);
        }, { passive: true });
      }
    }
    var num = root.querySelector('[data-astax-num]');
    var fill = root.querySelector('[data-astax-fill]');
    var arrow = root.querySelector('[data-astax-arrow]');
    if (!num) return;
    if (!reduce()) num.textContent = fmtCount(num, 0);
    var axEase = bezier(0.215, -0.001, 0.211, 1.001);
    var axIv = null, axT = null;
    function run() {
      var to = 6000;
      var fmt = function (v) { return fmtCount(num, v); };
      if (reduce()) { num.textContent = fmt(to); if (fill) fill.style.width = '100%'; return; }
      var FILL_MS = 5000, HOLD_MS = 5000, DRAIN_MS = 1000;
      var easeUp = function (t) { return t >= 1 ? 1 : 1 - Math.pow(1 - t, 7); };
      var fillUp = function () {
        var start = performance.now();
        clearInterval(axIv);
        axIv = setInterval(function () {
          var t = (performance.now() - start) / FILL_MS; if (t > 1) t = 1;
          var e = easeUp(t);
          num.textContent = fmt(to * e);
          if (fill) fill.style.width = (e * 100).toFixed(2) + '%';
          if (arrow) {
            var v = to * e, ay;
            if (t < 0.06) ay = -11 * axEase(t / 0.06);
            else if (v < 5990) ay = -11;
            else ay = -11 * (1 - axEase((v - 5990) / 13));
            arrow.style.transform = 'translateY(' + ay.toFixed(2) + 'px)';
          }
          if (t >= 1) {
            clearInterval(axIv); num.textContent = fmt(to); if (fill) fill.style.width = '100%';
            if (arrow) { arrow.style.transition = 'transform .14s ease-out'; arrow.style.transform = 'translateY(0)'; setTimeout(function () { arrow.style.transition = ''; }, 200); }
            axT = setTimeout(drain, HOLD_MS);
          }
        }, 16);
      };
      var drain = function () {
        var start = performance.now();
        clearInterval(axIv);
        axIv = setInterval(function () {
          var t = (performance.now() - start) / DRAIN_MS; if (t > 1) t = 1;
          if (fill) fill.style.width = ((1 - t) * 100).toFixed(2) + '%';
          if (t >= 1) { clearInterval(axIv); if (fill) fill.style.width = '0%'; num.textContent = fmt(0); fillUp(); }
        }, 16);
      };
      fillUp();
    }
    var done = false;
    ticks.push(function () {
      if (done) return;
      var vh = window.innerHeight || 0;
      if (root.getBoundingClientRect().top < vh * 0.85) { done = true; run(); }
    });
  }

  /* ---------- What happens inside ---------- */
  function initInside(root) {
    var items = root.querySelectorAll('[data-step-item]');
    var dots = root.querySelectorAll('[data-step-dot]');
    var label = root.querySelector('[data-step-label]');
    function setStep(n) {
      items.forEach(function (it) {
        var i = parseInt(it.dataset.stepItem, 10);
        var body = it.querySelector('[data-step-body]');
        if (body) body.style.display = i === n ? '' : 'none';
      });
      dots.forEach(function (d) {
        var i = parseInt(d.dataset.stepDot, 10);
        var on = d.querySelector('[data-dot-on]');
        if (on) on.style.display = i === n ? '' : 'none';
      });
      var it = root.querySelector('[data-step-item="' + n + '"]');
      if (label && it) label.textContent = String(n + 1).padStart(2, '0') + ' · ' + (it.dataset.stepTitle || '');
    }
    items.forEach(function (it) {
      var go = function () { setStep(parseInt(it.dataset.stepItem, 10)); };
      it.addEventListener('mouseenter', go); it.addEventListener('click', go);
    });
    dots.forEach(function (d) {
      d.addEventListener('mouseenter', function () { setStep(parseInt(d.dataset.stepDot, 10)); });
    });
    setStep(0);
    // reveal
    var seen = false;
    ticks.push(function () {
      if (seen) return;
      var vh = window.innerHeight || 0;
      if (root.getBoundingClientRect().top < vh * 0.82) {
        seen = true;
        root.querySelectorAll('.zph-rvl').forEach(function (el) { el.classList.add('zph-in'); });
      }
    });
  }

  /* ---------- Diet section ---------- */
  function initDiet(root) {
    var modal = root.querySelector('[data-diet-modal]');
    var panels = root.querySelectorAll('[data-diet-panel]');
    var pills = root.querySelectorAll('[data-modal-tab]');
    var strip = modal && modal.querySelector('[data-modal-tabstrip]');
    var cur = -1, tsx = 0, rot = 0;

    /* rot = index of the pill currently sitting first in the strip (0 = authored order) */
    function applyOrder() {
      var n = pills.length;
      pills.forEach(function (p, i) { p.style.order = rot ? ((i - rot + n) % n) : ''; });
    }
    /* Flex `order` cannot be transitioned, so the pills are moved with a FLIP pass:
       note where each one is, re-order, then translate them back to their old spots
       and release on the next frame so they slide into place. The forced scroll reset
       is part of the same layout change, so it rides along in one movement.
       Only the pills travelling LEFT slide. The ones wrapping around to the back of
       the strip would otherwise cut straight through the row and collide with them
       mid-flight, so they fade in at their new spot instead. */
    function rotateTo(k, animate) {
      if (rot === k || !strip) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var first = [];
      pills.forEach(function (p, i) { first[i] = p.getBoundingClientRect().left; });
      rot = k;
      applyOrder();
      strip.scrollLeft = 0;
      if (!animate || reduce) return;
      var last = [];
      pills.forEach(function (p, i) { last[i] = p.getBoundingClientRect().left; });
      strip.classList.add('zph-tabs-flip');
      pills.forEach(function (p, i) {
        var dx = first[i] - last[i];
        if (dx > 0) p.style.transform = 'translateX(' + dx + 'px)';
        else if (dx < 0) p.style.opacity = '0';
      });
      requestAnimationFrame(function () {
        strip.classList.remove('zph-tabs-flip');
        pills.forEach(function (p) { p.style.transform = ''; p.style.opacity = ''; });
      });
    }
    /* On phones the strip only re-orders when the active pill is NOT fully visible
       where it already sits; then it rotates so that pill leads and the rest wrap to
       its right. A pill already in view is left exactly where it is, so stepping
       through the ingredients doesn't reshuffle the row under the reader.
       Desktop keeps the centred strip and just scrolls the pill into view.
       offsetLeft/offsetWidth are layout units, so the card's pop-in scale can't skew
       the math; called once immediately and once after the animation settles.
       `animate` slides the pills across (see rotateTo) -- on set for an ingredient
       switch, off when the modal is first opened and the row hasn't been seen yet. */
    function fitTabs(smooth, animate) {
      var act = strip && strip.querySelector('[data-modal-tab="' + cur + '"]');
      if (!act) return;
      if (!(window.matchMedia && window.matchMedia('(max-width:640px)').matches)) {
        rotateTo(0, false);
        if (strip.scrollWidth <= strip.clientWidth + 4) return;
        var tl = act.offsetLeft - strip.offsetLeft;
        var tright = tl + act.offsetWidth;
        if (tright > strip.scrollLeft + strip.clientWidth + 1) {
          strip.scrollTo({ left: tright - strip.clientWidth + 8, behavior: smooth ? 'smooth' : 'auto' });
        } else if (tl < strip.scrollLeft + 1) {
          strip.scrollTo({ left: Math.max(0, tl - 8), behavior: smooth ? 'smooth' : 'auto' });
        }
        return;
      }
      var left = act.offsetLeft - strip.offsetLeft - strip.scrollLeft;
      if (left >= -1 && left + act.offsetWidth <= strip.clientWidth + 1) return;
      rotateTo(cur, animate);
    }

    function render(swapDir) {
      if (!modal) return;
      modal.style.display = cur >= 0 ? 'flex' : 'none';
      if (cur < 0) return;
      panels.forEach(function (p) { p.style.display = parseInt(p.dataset.dietPanel, 10) === cur ? '' : 'none'; });
      pills.forEach(function (p) {
        var on = parseInt(p.dataset.modalTab, 10) === cur;
        p.style.background = on ? 'var(--z-purple)' : 'transparent';
        p.style.color = on ? '#fff' : 'var(--z-muted)';
        p.style.borderColor = on ? 'var(--z-purple)' : 'var(--z-border)';
      });
      /* swapDir is set for an ingredient switch and absent on first open, which is
         exactly when the pills should slide rather than appear already re-ordered */
      var slide = !!swapDir;
      requestAnimationFrame(function () { fitTabs(false, slide); });
      setTimeout(function () { fitTabs(true, slide); }, 420);
      root.querySelectorAll('[data-diet-tab]').forEach(function (t) {
        var bar = t.querySelector('[data-tab-bar]');
        if (bar) bar.style.display = parseInt(t.dataset.dietTab, 10) === cur ? '' : 'none';
      });
      if (swapDir) {
        setTimeout(function () {
          modal.querySelectorAll('.zph-swap').forEach(function (el) {
            el.classList.remove('zph-swap-next', 'zph-swap-prev'); void el.offsetWidth;
            el.classList.add(swapDir >= 0 ? 'zph-swap-next' : 'zph-swap-prev');
          });
        }, 0);
      }
    }
    function open(i) { cur = i; render(); }
    function close() { cur = -1; render(); }
    /* pills.length, not panels.length: each ingredient owns two [data-diet-panel]
       elements (header + body) either side of the shared tab strip. */
    function step(dir) { if (cur < 0) return; cur = (cur + dir + pills.length) % pills.length; render(dir); }
    root.querySelectorAll('[data-diet-tab]').forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.dataset.dietTab, 10);
        cur = (cur === i) ? -1 : i; render();
      });
    });
    root.querySelectorAll('[data-food-card]').forEach(function (c) {
      c.addEventListener('click', function () { open(parseInt(c.dataset.foodCard, 10)); });
    });
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        var i = parseInt(p.dataset.modalTab, 10);
        if (i === cur) return;
        var dir = i > cur ? 1 : -1; cur = i; render(dir);
      });
    });
    if (modal) {
      modal.addEventListener('click', close);
      var card = modal.querySelector('.zph-modal-card');
      if (card) {
        card.addEventListener('click', function (e) { e.stopPropagation(); });
        card.addEventListener('touchstart', function (e) { tsx = e.touches[0] ? e.touches[0].clientX : 0; }, { passive: true });
        card.addEventListener('touchend', function (e) {
          var x = e.changedTouches[0] ? e.changedTouches[0].clientX : 0;
          var dx = x - tsx;
          if (dx > 45) step(-1); else if (dx < -45) step(1);
        });
      }
      modal.querySelectorAll('[data-diet-close]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); close(); }); });
      modal.querySelectorAll('[data-diet-prev]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); step(-1); }); });
      modal.querySelectorAll('[data-diet-next]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); step(1); }); });
      /* rotating the phone while the modal is open changes which pills fit: re-decide */
      var rsz;
      window.addEventListener('resize', function () {
        if (cur < 0) return;
        clearTimeout(rsz);
        rsz = setTimeout(function () { if (cur >= 0) render(); }, 150);
      });
    }
    // proportional counters + word-lock
    var eq = root.querySelector('[data-count-eq]');
    var eqDone = false;
    ticks.push(function () {
      if (eqDone || !eq) return;
      var vh = window.innerHeight || 0;
      if (eq.getBoundingClientRect().top < vh * 0.9) { eqDone = true; runCountProportional(eq); }
    });
    initWordLock(root);
  }

  /* "One skin tone nutrient daily": timed word reveal once it enters view */
  function initWordLock(root) {
    var wordsWrap = root.querySelector('#zph-words');
    if (!wordsWrap) return;
    var ws = wordsWrap.querySelectorAll('.zph-w');
    if (!ws.length) return;
    var played = false;
    function play() {
      if (played) return; played = true;
      ws.forEach(function (w, i) {
        setTimeout(function () { w.classList.add('zph-in'); }, 250 + i * 380);
      });
    }
    if (reduce()) { ws.forEach(function (w) { w.classList.add('zph-in'); }); played = true; return; }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { play(); io.disconnect(); } });
      }, { threshold: 0.6 });
      io.observe(wordsWrap);
    } else { play(); }
  }
  /* ---------- Orbit ---------- */
  function initOrbit(root) {
    var infos = root.querySelectorAll('[data-orbit-info]');
    var items = root.querySelectorAll('[data-orbit-item]');
    var cur = 0, pausedUntil = 0;
    function render() {
      infos.forEach(function (p) { p.style.display = parseInt(p.dataset.orbitInfo, 10) === cur ? '' : 'none'; });
      items.forEach(function (it) {
        var i = parseInt(it.dataset.orbitItem, 10);
        var sel = it.querySelector('[data-orbit-sel]');
        var img = it.querySelector('img');
        if (sel) { sel.style.opacity = i === cur ? '1' : '0'; sel.style.transform = 'scale(' + (i === cur ? 1 : 0.55) + ')'; }
        if (img) img.style.transform = 'scale(' + (i === cur ? 1.12 : 1) + ')';
      });
    }
    items.forEach(function (it) {
      var go = function () { pausedUntil = Date.now() + 9000; cur = parseInt(it.dataset.orbitItem, 10); render(); };
      it.addEventListener('mouseenter', go); it.addEventListener('click', go);
    });
    setInterval(function () {
      if (Date.now() < pausedUntil) return;
      cur = (cur + 1) % (infos.length || 3); render();
    }, 5000);
    render();
  }

  /* ---------- Simple modal helper (doctor, guarantee) ---------- */
  function bindModal(root, modalSel, openSel, closeSel) {
    var modal = root.querySelector(modalSel);
    if (!modal) return null;
    function open(e) { if (e && e.preventDefault) e.preventDefault(); modal.style.display = 'flex'; }
    function close() { modal.style.display = 'none'; }
    root.querySelectorAll(openSel).forEach(function (b) { b.addEventListener('click', open); });
    modal.addEventListener('click', close);
    var card = modal.querySelector('.zph-modal-card');
    if (card) card.addEventListener('click', function (e) { e.stopPropagation(); });
    modal.querySelectorAll(closeSel).forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); close(); }); });
    return { open: open, close: close, el: modal };
  }
  function initDoctor(root) {
    bindModal(root, '[data-dr-modal]', '[data-dr-open]', '[data-dr-close]');
  }

  /* ---------- 90-day curve ---------- */
  function initCurve(root) {
    var line = root.querySelector('#zph-curve-line');
    var area = root.querySelector('#zph-curve-area');
    var lead = root.querySelector('#zph-curve-lead');
    var msK = root.querySelector('[data-ms-k]');
    var msD = root.querySelector('[data-ms-d]');
    var msPill = root.querySelector('[data-ms-pill]');
    var milestones = [];
    try { milestones = JSON.parse(root.querySelector('[data-ms-json]').textContent); } catch (e) { }
    var state = { ms: 3, played: false, looping: false, pausedUntil: 0 };
    /* startPass is built inside playCurve (it closes over the path measurements),
       so the visibility observer below needs a handle on it from out here. */
    var curveIV = null, loopTO = null, startPassRef = null;
    function setMs(n) {
      state.ms = n;
      if (msK && milestones[n]) msK.textContent = milestones[n].k;
      if (msD && milestones[n]) msD.firstChild.textContent = milestones[n].d + ' ';
      if (msPill) msPill.style.display = n === 3 ? '' : 'none';
    }
    var pts = [[72, 224], [275, 150], [477, 104], [680, 80]];
    function nodeEl(i) { return root.querySelector('#nd' + i); }
    function playCurve() {
      if (state.played || !line) return;
      state.played = true; state.looping = true;
      var total; try { total = line.getTotalLength(); } catch (e) { total = 599; }
      var segLen = [], i;
      for (i = 1; i < pts.length; i++) segLen.push(Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]));
      var totalLen = segLen.reduce(function (a, b) { return a + b; }, 0);
      var nodeFrac = [0], acc = 0;
      segLen.forEach(function (l) { acc += l; nodeFrac.push(acc / totalLen); });
      line.setAttribute('stroke-dasharray', total);
      var gBtn = root.querySelector('button[data-guarantee-open]');
      var nodeReached = function (i) {
        var el = nodeEl(i); if (el) el.setAttribute('fill', i === 3 ? '#5aa056' : '#2A1240');
        if (i === 3 && gBtn) gBtn.classList.add('zph-g-open');
      };
      var resetNodes = function () {
        [0, 1, 2].forEach(function (i) { var e = nodeEl(i); if (e) e.setAttribute('fill', '#ffffff'); });
        var n3 = nodeEl(3); if (n3) n3.setAttribute('fill', '#5aa056');
        root.querySelectorAll('.zph-supply').forEach(function (el) { el.classList.remove('zph-in'); });
        if (gBtn) gBtn.classList.remove('zph-g-open');
      };
      var supplies = Array.prototype.slice.call(root.querySelectorAll('.zph-supply'));
      var showSupply = function (i) { if (supplies[i]) supplies[i].classList.add('zph-in'); };
      if (reduce()) {
        line.setAttribute('stroke-dashoffset', 0);
        if (area) area.style.opacity = 1;
        [0, 1, 2, 3].forEach(nodeReached); [0, 1, 2].forEach(showSupply);
        if (lead) lead.style.opacity = 0;
        setMs(3); return;
      }
      var durations = [5000, 5000, 5000];
      var totalDur = durations.reduce(function (a, b) { return a + b; }, 0);
      var easeInOut = function (x) { return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2; };
      var startPass = function () {
        resetNodes();
        line.setAttribute('stroke-dashoffset', total);
        if (area) area.style.opacity = 1;
        if (lead) { lead.setAttribute('cx', pts[0][0]); lead.setAttribute('cy', pts[0][1]); lead.style.opacity = 1; }
        nodeReached(0); showSupply(0); setMs(0);
        var t0 = performance.now();
        clearInterval(curveIV);
        curveIV = setInterval(function () {
          var elapsed = performance.now() - t0; if (elapsed > totalDur) elapsed = totalDur;
          var seg = 0, accT = 0;
          while (seg < durations.length - 1 && elapsed >= accT + durations[seg]) { accT += durations[seg]; seg++; }
          var localT = durations[seg] ? Math.min(1, (elapsed - accT) / durations[seg]) : 1;
          var frac = nodeFrac[seg] + (nodeFrac[seg + 1] - nodeFrac[seg]) * easeInOut(localT);
          var dist = frac * total;
          line.setAttribute('stroke-dashoffset', total - dist);
          if (lead) { try { var p = line.getPointAtLength(dist); lead.setAttribute('cx', p.x); lead.setAttribute('cy', p.y); } catch (e) { } }
          if (state.ms !== seg && elapsed < totalDur && Date.now() > state.pausedUntil) setMs(seg);
          for (var i = 1; i < nodeFrac.length; i++) {
            if (frac >= nodeFrac[i] - 0.0008) { nodeReached(i); if (i <= 2) showSupply(i); }
          }
          if (elapsed >= totalDur) {
            setMs(3); nodeReached(3);
            if (lead) lead.style.opacity = 0;
            clearInterval(curveIV); clearTimeout(loopTO);
            loopTO = setTimeout(function () { if (state.looping) startPass(); }, 5200);
          }
        }, 16);
      };
      startPassRef = startPass;
      startPass();
    }
    [0, 1, 2, 3].forEach(function (i) {
      var el = nodeEl(i);
      if (el) el.addEventListener('mouseenter', function () { state.pausedUntil = Date.now() + 6000; setMs(i); });
    });
    var guarantee = bindModal(root, '[data-guarantee-modal]', '[data-guarantee-open]', '[data-guarantee-close]');
    // guarantee accordions
    root.querySelectorAll('[data-gq]').forEach(function (row) {
      var head = row.querySelector('[data-gq-head]');
      var body = row.querySelector('[data-gq-body]');
      if (!head) return;
      head.addEventListener('click', function () {
        var isOpen = row.classList.contains('zph-acc-open');
        root.querySelectorAll('[data-gq]').forEach(function (r) {
          r.classList.remove('zph-acc-open');
          var b = r.querySelector('[data-gq-body]'); if (b) b.style.display = 'none';
          /* the head now carries aria-expanded, so it has to track the class
             rather than sit at its markup default forever */
          var h = r.querySelector('[data-gq-head]');
          if (h && h.hasAttribute('aria-expanded')) h.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          row.classList.add('zph-acc-open');
          if (body) body.style.display = '';
          if (head.hasAttribute('aria-expanded')) head.setAttribute('aria-expanded', 'true');
        }
      });
    });
    ticks.push(function () {
      if (state.played) return;
      var vh = window.innerHeight || 0;
      var cr = root.getBoundingClientRect();
      if (cr.top < vh * 0.66 && cr.bottom > vh * 0.2) playCurve();
    });
    /* state.looping was set once and never cleared, so after the section had been
       seen a single time this ran a 16ms interval for 15s, waited 5.2s, and did
       it again — forever, and on every template carrying the section, however
       far off screen it had scrolled. Each pass writes SVG attributes and calls
       getPointAtLength ~940 times, which is real layout work.

       Suspend the cycle when the section leaves the viewport and restart a pass
       when it comes back. state.played stays true so the entry tick above never
       re-fires; only the loop is parked. */
    if (window.IntersectionObserver) {
      var cvIO = new IntersectionObserver(function (entries) {
        var vis = entries.some(function (e) { return e.isIntersecting; });
        if (vis === state.looping) return;
        state.looping = vis;
        if (vis) {
          if (startPassRef) startPassRef();
        } else {
          clearInterval(curveIV); curveIV = null;
          clearTimeout(loopTO); loopTO = null;
        }
      }, { rootMargin: '200px 0px' });
      cvIO.observe(root);
    }
    setMs(3);
  }

  /* ---------- Reviews ---------- */
  function initReviews(root) {
    var rail = root.querySelector('.zph-rev-rail');
    var prevB = root.querySelector('[data-rail-prev]');
    var nextB = root.querySelector('[data-rail-next]');
    /* rail crop groups are authored at 272x340; scale each to its card width */
    function updRailScale() {
      root.querySelectorAll('.zph-rev-card').forEach(function (c) {
        if (c.clientWidth > 0) c.style.setProperty('--zph-rscale', c.clientWidth / 272);
      });
    }
    updRailScale();
    window.addEventListener('resize', updRailScale);
    /* clientWidth can still change after init — web fonts landing, images
       decoding, a scrollbar appearing. rscale is written once as an inline
       style, so a stale reading leaves the 272px crop stage narrower than its
       card and a hairline of card shows down the right edge for the life of
       the page. Re-measure when the box actually changes rather than trusting
       the first read; resize alone never fires for any of these. */
    if (window.ResizeObserver) {
      var rro = new ResizeObserver(updRailScale);
      root.querySelectorAll('.zph-rev-card').forEach(function (c) { rro.observe(c); });
    }
    window.addEventListener('load', updRailScale);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(updRailScale);
    if (rail) {
      var upd = function () {
        var max = rail.scrollWidth - rail.clientWidth;
        var atStart = rail.scrollLeft <= 2, atEnd = rail.scrollLeft >= max - 2;
        if (prevB) { prevB.style.opacity = atStart ? '0.3' : '1'; prevB.style.pointerEvents = atStart ? 'none' : 'auto'; }
        if (nextB) { nextB.style.opacity = atEnd ? '0.3' : '1'; nextB.style.pointerEvents = atEnd ? 'none' : 'auto'; }
      };
      rail.addEventListener('scroll', upd, { passive: true });
      setTimeout(upd, 100); window.addEventListener('resize', upd);
      if (prevB) prevB.addEventListener('click', function () { rail.scrollBy({ left: -230, behavior: 'smooth' }); });
      if (nextB) nextB.addEventListener('click', function () { rail.scrollBy({ left: 230, behavior: 'smooth' }); });
    }
    // modal carousel
    var modal = root.querySelector('[data-review-modal]');
    if (!modal) return;
    var track = modal.querySelector('[data-review-track]');
    var slides = modal.querySelectorAll('[data-review-slide]');
    var dots = modal.querySelectorAll('[data-review-dot]');
    var mPrev = modal.querySelector('[data-review-prev]');
    var mNext = modal.querySelector('[data-review-next]');
    var idx = -1, rdx = 0, drag = false;
    /* widget crop values are authored against a 460px-wide modal frame;
       scale the fixed stage so they hold at any rendered width.

       mscale is written once as an inline style from a single measurement, so a
       reading taken before the box settles sticks for the life of the page and
       leaves the 460px stage narrower than its frame — a strip of the frame's own
       background then shows down the right edge of the photo and never goes away.
       Anything that reflows the modal after it opens does it: a consent banner
       landing, a web font arriving, the photo decoding, an orientation change.
       window.resize fires for none of those, so measure the frames themselves.
       (initRail has carried the same guard since the rail hit this; the modal
       never got it.) */
    function updStageScale() {
      modal.querySelectorAll('[data-ba-card]').forEach(function (f) {
        if (f.clientWidth > 0) f.style.setProperty('--zph-mscale', f.clientWidth / 460);
      });
    }
    window.addEventListener('resize', updStageScale);
    if (window.ResizeObserver) {
      var mro = new ResizeObserver(updStageScale);
      modal.querySelectorAll('[data-ba-card]').forEach(function (f) { mro.observe(f); });
    }
    window.addEventListener('load', updStageScale);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(updStageScale);
    function render() {
      modal.style.display = idx >= 0 ? 'flex' : 'none';
      if (idx < 0) return;
      updStageScale();
      if (track) track.style.transform = 'translateX(-' + (Math.max(idx, 0) * 100) + '%)';
      dots.forEach(function (d, i) { d.style.background = i === idx ? 'var(--z-purple)' : 'rgba(42,18,64,0.18)'; });
      /* keep disabled arrows interactive: with pointer-events:none the press
         falls through onto the compare-slider drag underneath */
      if (mPrev) { mPrev.style.opacity = idx <= 0 ? '0.4' : '1'; mPrev.style.pointerEvents = 'auto'; }
      if (mNext) { mNext.style.opacity = idx >= slides.length - 1 ? '0.4' : '1'; mNext.style.pointerEvents = 'auto'; }
    }
    function step(dir) {
      if (idx < 0) return;
      var nx = Math.min(slides.length - 1, Math.max(0, idx + dir));
      if (nx !== idx) { idx = nx; render(); }
    }
    root.querySelectorAll('[data-rev-open]').forEach(function (c) {
      c.addEventListener('click', function () { idx = parseInt(c.dataset.revOpen, 10); render(); });
    });
    /* Page-level opener: anything on the page can pop this modal via
       data-zph-open-review="<0-based slide>" (the proof-cards compare tile uses
       it). Queried off document, not root, because those live in other sections;
       only wired once the modal exists, so the pointer affordance is never dead. */
    document.querySelectorAll('[data-zph-open-review]').forEach(function (el) {
      if (el.dataset.zphRevBound) return;
      el.dataset.zphRevBound = '1';
      el.classList.add('zph-rev-linked');
      if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      var openIt = function (e) {
        if (e && e.preventDefault) e.preventDefault();
        var n = parseInt(el.dataset.zphOpenReview, 10);
        if (isNaN(n)) n = 0;
        idx = Math.min(slides.length - 1, Math.max(0, n));
        render();
      };
      el.addEventListener('click', openIt);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') openIt(e);
      });
    });
    modal.addEventListener('click', function () { idx = -1; render(); });
    var card = modal.querySelector('.zph-modal-card');
    if (card) card.addEventListener('click', function (e) { e.stopPropagation(); });
    modal.querySelectorAll('[data-review-close]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); idx = -1; render(); });
    });
    if (mPrev) mPrev.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    if (mNext) mNext.addEventListener('click', function (e) { e.stopPropagation(); step(1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { if (i !== idx) { idx = i; render(); } }); });
    var zone = modal.querySelector('[data-review-swipe]');
    if (zone) {
      /* A drag that starts on the before/after image is a COMPARE gesture, never a
         carousel swipe — dragging the divider must not jump you to someone else's
         review. The card stops click/touchstart/touchmove but not mousedown/mouseup,
         so the compare drag used to reach us here and step() past 45px.
         Both paths are armed only by a start that landed outside the compare card,
         so a stale start X can't step the carousel on release either. */
      var inCompare = function (e) {
        var t = e.target;
        return !!(t && t.closest && t.closest('[data-ba-card]'));
      };
      var tArmed = false;
      zone.addEventListener('touchstart', function (e) {
        if (inCompare(e)) { tArmed = false; return; }
        tArmed = true;
        rdx = e.touches[0] ? e.touches[0].clientX : 0;
      }, { passive: true });
      zone.addEventListener('touchend', function (e) {
        if (!tArmed) return;
        tArmed = false;
        if (inCompare(e)) return;
        var x = e.changedTouches[0] ? e.changedTouches[0].clientX : 0;
        var dx = x - rdx;
        if (dx > 45) step(-1); else if (dx < -45) step(1);
      });
      zone.addEventListener('mousedown', function (e) {
        if (inCompare(e)) { drag = false; return; }
        rdx = e.clientX; drag = true;
      });
      zone.addEventListener('mouseup', function (e) {
        if (!drag) return; drag = false;
        if (inCompare(e)) return;
        var dx = e.clientX - rdx;
        if (dx > 45) step(-1); else if (dx < -45) step(1);
      });
    }
    render();
  }

  /* ---------- Welcome kit scroll video ---------- */
  function initKit(root) {
    var sec = root.querySelector('[data-kit-scroll]');
    var vw = root.querySelector('[data-kit-videowrap]');
    var txt = root.querySelector('[data-kit-text]');
    var vid = root.querySelector('[data-kit-video]');
    var canvas = root.querySelector('[data-kit-canvas]');
    if (!sec || !vid || !canvas) return;
    var mob = window.innerWidth <= 640;
    // phones decode a 540px encode into fewer frames: ~4x less RAM and bandwidth than desktop
    /* frames x cap^2 x 4 bytes of canvas backing store, retained for the life of
       the page: 120 @ 900px was ~389MB desktop, 100 @ 540px ~117MB mobile. The
       scrub is far denser than the eye can follow — 48/60 frames at a smaller cap
       reads identically against a 560vh scroll and costs roughly a tenth. */
    var st = { vidReq: false, cacheStarted: false, cacheReady: false, frames: [], dur: 0, fi: -1, ctx: null, cap: mob ? 480 : 720, n: mob ? 48 : 60 };
    function buildCache() {
      if (st.cacheStarted) return;
      var dur = vid.duration;
      if (!dur || !isFinite(dur)) return;
      if (!vid.requestVideoFrameCallback) return;
      if (!(vid.seekable && vid.seekable.length && vid.seekable.end(vid.seekable.length - 1) > dur - 1)) return;
      st.cacheStarted = true;
      var CAP = st.cap, N = st.n, idx = 0;
      st.dur = dur;
      function grab() {
        var c = document.createElement('canvas'); c.width = CAP; c.height = CAP;
        try { c.getContext('2d').drawImage(vid, 0, 0, CAP, CAP); } catch (e) { }
        st.frames.push({ t: (idx / (N - 1)) * (dur - 0.05), c: c });
        if (st.frames.length === 1) { canvas.width = CAP; canvas.height = CAP; st.ctx = canvas.getContext('2d'); st.ctx.drawImage(c, 0, 0); }
        idx++;
        if (idx % 4 === 0) { st.fi = -1; tick(); }
        if (idx < N) next();
        else {
          st.cacheReady = true;
          /* every frame is now on a canvas — the decoded video is dead weight */
          if (st.objUrl) { try { URL.revokeObjectURL(st.objUrl); } catch (e) { } st.objUrl = null; }
          st.fi = -1; tick();
        }
      }
      function next() {
        /* A same-position seek presents no new frame, so waiting on rVFC alone can
           stall the whole cache (happens on warm-cache reloads mid-section). Race the
           frame callback against 'seeked' + a watchdog; first one advances, once. */
        var done = false;
        function advance() {
          if (done) return; done = true;
          vid.removeEventListener('seeked', onSeek);
          grab();
        }
        function onSeek() { setTimeout(advance, 20); }
        vid.requestVideoFrameCallback(function () { advance(); });
        vid.addEventListener('seeked', onSeek);
        setTimeout(advance, 500);
        var t = (idx / (N - 1)) * (dur - 0.05);
        if (t < 0.01) t = 0.01;
        try { vid.currentTime = t; } catch (e) { setTimeout(advance, 0); }
      }
      try { vid.muted = true; } catch (e) { }
      next();
    }
    function draw(vp) {
      if (!st.frames.length) return; // progressive: nearest built frame, full cache not required
      if (!st.ctx) st.ctx = canvas.getContext('2d');
      if (vp < 0) vp = 0; if (vp > 1) vp = 1;
      var tt = vp * ((st.dur || 1) - 0.05);
      var fr = st.frames, lo = 0, hi = fr.length - 1;
      while (lo < hi) { var mid = (lo + hi) >> 1; if (fr[mid].t < tt) lo = mid + 1; else hi = mid; }
      var i = lo;
      if (i > 0 && Math.abs(fr[i - 1].t - tt) < Math.abs(fr[i].t - tt)) i = i - 1;
      if (i !== st.fi) { st.fi = i; st.ctx.drawImage(fr[i].c, 0, 0); }
    }
    function tick() {
      if (!st.vidReq) {
        st.vidReq = true;
        try {
          /* the <source> now carries data-src, not src: with a plain src the
             browser pulled the desktop mp4 on its own AND we fetched the mobile
             one here, so phones downloaded both files for one clip */
          var srcEl = vid.querySelector('source');
          var srcAttr = srcEl && (srcEl.getAttribute('data-src') || srcEl.getAttribute('src'));
          var url = (mob && vid.dataset.srcMobile) || srcAttr || vid.currentSrc || vid.src;
          if (url) {
            fetch(url).then(function (r) { return r.blob(); }).then(function (b) {
              /* Hold the object URL until the frame cache is finished. buildCache
                 seeks this element dozens of times AFTER loadeddata, so revoking
                 there pulled the source out mid-build and left the scrubber with
                 no frames — a dead animation. st.objUrl is released in buildCache
                 once cacheReady flips. */
              st.objUrl = URL.createObjectURL(b);
              vid.src = st.objUrl; vid.load();
              vid.addEventListener('loadeddata', function () { buildCache(); }, { once: true });
            }).catch(function () { });
          }
        } catch (e) { }
      }
      buildCache();
      var vEnd = 0.6, mStart = 0.58, mEnd = 0.86, tStart = 0.82;
      var vh = window.innerHeight || 0;
      var r = sec.getBoundingClientRect();
      var span = (r.height - vh) || 1;
      var p = (-r.top) / span; if (p < 0) p = 0; if (p > 1) p = 1;
      var vp = vEnd > 0 ? p / vEnd : 1; if (vp < 0) vp = 0; if (vp > 1) vp = 1;
      draw(vp);
      var mp = (p - mStart) / ((mEnd - mStart) || 1); if (mp < 0) mp = 0; if (mp > 1) mp = 1;
      var me = mp * mp * (3 - 2 * mp);
      if (vw) {
        if (mob) {
          /* phones: full-size while scrubbing, then fit the box into whatever
             space remains above the incoming text — big on tall screens,
             smaller only where it must be */
          /* measure the sticky stage itself: CSS 100vh and window.innerHeight
             disagree on phones (URL bar), and the layout follows the CSS value */
          var stH = (vw.offsetParent && vw.offsetParent.clientHeight) || window.innerHeight || 700;
          var baseH = vw.offsetHeight || 1;
          var txtH = txt ? txt.getBoundingClientRect().height : 0;
          var textTop = stH - Math.max(20, stH * 0.05) - txtH;
          var availTop = 66;
          var availH = Math.max(120, textTop - 18 - availTop);
          var endScale = Math.min(1, availH / baseH);
          var endCy = availTop + availH / 2;
          var ty = (endCy - stH * 0.40) * me;
          vw.style.transform = 'translate(-50%,-50%) translateY(' + ty.toFixed(1) + 'px) scale(' + (1 + (endScale - 1) * me).toFixed(3) + ')';
        } else {
          var shift = me * -Math.min((window.innerWidth || 1200) * 0.18, 270), sc = 1 - me * 0.26;
          vw.style.transform = 'translate(-50%,-50%) translateX(' + shift.toFixed(1) + 'px) scale(' + sc.toFixed(3) + ')';
        }
      }
      var tp = (p - tStart) / ((0.99 - tStart) || 1); if (tp < 0) tp = 0; if (tp > 1) tp = 1;
      var te = tp * tp * (3 - 2 * tp);
      if (txt) { txt.style.opacity = te.toFixed(3); txt.style.transform = (mob ? '' : 'translateY(-50%) ') + 'translateY(' + ((1 - te) * 24).toFixed(1) + 'px)'; }
    }
    /* tick() kicks off the video fetch and the canvas frame cache on its first
       call, and it used to be called immediately — so a section 14 of 16 down the
       page was pulling its video and rasterising frames while the hero was still
       painting, competing directly with LCP. Nothing here is visible until the
       section is close, so hold everything until it is. */
    ticks.push(function () { if (st.armed) tick(); });
    function arm() {
      if (st.armed) return;
      st.armed = true;
      tick();
      [400, 1000, 2200, 4000].forEach(function (ms) { setTimeout(function () { st.fi = -1; tick(); }, ms); });
    }
    if (window.IntersectionObserver) {
      var kio = new IntersectionObserver(function (e) {
        if (e.some(function (x) { return x.isIntersecting; })) { kio.disconnect(); arm(); }
      }, { rootMargin: '1200px 0px' });
      kio.observe(sec);
    }
    /* Backstop: the observer alone left the canvas blank for anyone who reached
       the section faster than the cache could build. `load` fires after LCP, so
       arming there costs nothing we care about and guarantees the frames exist
       well before the section is reached by normal scrolling. */
    window.addEventListener('load', function () {
      arm();
      st.fi = -1;
      tick();
    });
  }

  /* ---------- Footer (lottie shore + flamingo + ripples) ---------- */
  function initFooter(root) {
    var scene = root.querySelector('#zsf-scene');
    if (!scene) return;
    var st = { curP: 0, targetP: 0, ripples: null, ease: null, sailFull: null };
    var isReduce = reduce();
    var sun = root.querySelector('#zsf-sun');
    var vL = root.querySelector('#zsf-village-l');
    var vR = root.querySelector('#zsf-village-r');
    var boat = root.querySelector('#zsf-boat');
    var sailM = root.querySelector('#zsf-sail-main');
    var sailJ = root.querySelector('#zsf-sail-jib');
    function measure() {
      var vh = window.innerHeight || 0;
      var r = scene.getBoundingClientRect();
      var span = (vh - r.height) || 1;
      var p = (span - r.top) / span;
      p = Math.max(0, Math.min(1, p));
      if (isReduce) p = 1;
      st.targetP = p;
    }
    function applyScene(p) {
      /* sun rises from fully below the horizon */
      if (sun) sun.setAttribute('transform', 'translate(0,' + (390 * (1 - p)).toFixed(1) + ')');
      /* villages: static artworks sliding in toward the center */
      var slide = 150 * (1 - p);
      if (vL) vL.setAttribute('transform', 'translate(' + (-slide).toFixed(1) + ',0)');
      if (vR) vR.setAttribute('transform', 'translate(' + slide.toFixed(1) + ',0)');
      /* boat: the flamingo's route — left edge 10% to 75% of scene width */
      if (boat) boat.setAttribute('transform', 'translate(' + ((0.10 + p * 0.65) * 1600 + 57).toFixed(1) + ',477)');
      /* sails: two stages — sailing shape, then the downwind balloon (the old head-turn point) */
      var full = p > 0.62;
      if (st.sailFull !== full && sailM && sailJ) {
        st.sailFull = full;
        sailM.setAttribute('d', full ? 'M 1 -106 L 1 -18 L -35 -14 Q -2 -50 1 -106 Z' : 'M 1 -106 L 1 -18 L -33 -14 Q -6 -52 1 -106 Z');
        sailJ.setAttribute('d', full ? 'M 2 -102 Q 45 -56 40 -10 L 9 -13 Q 21 -50 2 -102 Z' : 'M 2 -102 L 40 -10 L 12 -13 Q 17 -52 2 -102 Z');
      }
    }
    function applyRipples(p) {
      if (!st.ripples) {
        st.ripples = Array.prototype.slice.call(root.querySelectorAll('#zsf-ripples [data-reveal]'));
        st.ripples.forEach(function (r) { r.style.transformBox = 'fill-box'; r.style.transformOrigin = 'center'; });
        if (!st.ripples.length) { st.ripples = null; return; }
      }
      if (!st.ease) st.ease = bezier(0.515, 0.02, 0.244, 0.983);
      st.ripples.forEach(function (r) {
        var rev = parseFloat(r.dataset.reveal) || 0;
        var peak = parseFloat(r.dataset.peak); var pk = isNaN(peak) ? 1 : peak;
        var t = (p - rev) / (1 - rev);
        t = t < 0 ? 0 : (t > 1 ? 1 : t);
        var e = st.ease(t);
        var o = e * pk; if (o < 0) o = 0;
        r.style.opacity = o.toFixed(3);
        r.style.transform = 'scaleX(' + (0.5 + 0.5 * t).toFixed(3) + ')';
      });
    }
    function shouldRun() {
      if (!st.near) return false;
      return Math.abs((st.targetP || 0) - st.curP) >= 0.0005;
    }
    function loop() {
      st.raf = 0;
      var tgt = st.targetP || 0;
      st.curP += (tgt - st.curP) * 0.08;
      if (Math.abs(tgt - st.curP) < 0.0005) st.curP = tgt;
      var pv = st.curP;
      applyScene(pv);
      applyRipples(pv);
      if (shouldRun()) st.raf = requestAnimationFrame(loop);
    }
    function kick() {
      if (!st.raf && st.near) st.raf = requestAnimationFrame(loop);
    }
    /* `near` is driven by an observer rather than the scroll tick so that a
       stationary reader parked on the footer still animates */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (e) {
        st.near = e.some(function (x) { return x.isIntersecting; });
        kick();
      }, { rootMargin: '200px 0px' }).observe(scene);
    } else {
      st.near = true;
    }
    ticks.push(function () { measure(); kick(); });
    measure();
    applyScene(st.curP);
    kick();
  }

  /* ---------- Global fades ---------- */
  var fades = [];
  function collectFades() {
    if (reduce()) {
      document.querySelectorAll('.zph-fade').forEach(function (el) { el.classList.add('zph-vis'); });
      fades = [];
      return;
    }
    fades = Array.prototype.slice.call(document.querySelectorAll('.zph-fade:not(.zph-vis)'));
  }
  ticks.push(function () {
    if (!fades.length) return;
    var vh = window.innerHeight || 0;
    for (var i = fades.length - 1; i >= 0; i--) {
      if (fades[i].getBoundingClientRect().top < vh * 0.9) {
        fades[i].classList.add('zph-vis');
        fades.splice(i, 1);
      }
    }
  });

  /* ---------- Boot ---------- */
  var inits = {
    header: initHeader, hero: initHero, research: initResearch, numbers: initNumbers,
    delivery: initDelivery, inside: initInside, diet: initDiet, orbit: initOrbit,
    doctor: initDoctor, curve: initCurve, reviews: initReviews, kit: initKit, footer: initFooter
  };
  /* The before/after slider initialiser used to be defined twice, byte for
     byte, in two different IIFEs. Only the second one was ever called, so
     edits landing on this copy silently did nothing. Removed; the live copy
     is the one further down, next to its call site. */

  function initAll() {
    document.querySelectorAll('[data-zph]').forEach(function (root) {
      if (root.dataset.zphInit) return;
      root.dataset.zphInit = '1';
      var fn = inits[root.dataset.zph];
      if (fn) try { fn(root); } catch (e) { if (window.console) console.error('zph init', root.dataset.zph, e); }
    });
    collectFades();
    onScroll();
  }
  /* Every tick reads layout, so running them straight out of the scroll event was
     costing a forced reflow per handler. Worse, this was bound to BOTH document
     (capture) and window (bubble), so the whole array ran twice per scroll — and
     the capture binding also caught scrolls from nested scrollers like the review
     rail and the PDP thumb strip, running the entire homepage loop for them.
     One binding now, coalesced into a single rAF per frame. */
  var scrollRaf = 0;
  function runTicks() {
    scrollRaf = 0;
    for (var i = 0; i < ticks.length; i++) { try { ticks[i](); } catch (e) { } }
  }
  /* The ticks only ran while the page was moving, so anything that settled
     AFTER the last scroll event was never seen. The nav reads the colour behind
     itself, and on the reviews page a sticky section finishes riding up a beat
     after the scroll stops — measured, the bar sat light over a background of
     luminance 0.41 and stayed that way, because its last reading was taken
     mid-move.

     Two catch-up runs after the page goes quiet fix that. They are debounced,
     so a continuous scroll schedules and reschedules without ever firing, and
     the cost once it lands is two frames. */
  var settleA = 0, settleB = 0;
  function onScroll() {
    clearTimeout(settleA); clearTimeout(settleB);
    settleA = setTimeout(runTicks, 180);
    settleB = setTimeout(runTicks, 600);
    if (scrollRaf) return;
    scrollRaf = requestAnimationFrame(runTicks);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  setTimeout(onScroll, 300);
  document.addEventListener('shopify:section:load', function () { setTimeout(initAll, 50); });
})();

/* ============ PDP + timeline runtime (self-contained) ============ */
(function () {
  'use strict';
  if (window.__ZPH_PDP__) return;
  window.__ZPH_PDP__ = true;
  var reduce = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function initPdp(root) {
    /* gallery */
    var mains = root.querySelectorAll('[data-g-main]');
    var thumbs = root.querySelectorAll('[data-g-thumb]');
    var galIdx = 0;
    function goTo(i, dir) {
      if (i < 0 || i >= mains.length) return;
      var from = galIdx;
      galIdx = i;
      mains.forEach(function (m) {
        m.classList.remove('zph-slide-in', 'zph-slide-out', 'zph-slide-back');
        m.classList.toggle('active', +m.dataset.gMain === i);
      });
      /* phones: the two shots slide as a pair -- the new one in from the edge you
         swiped towards, the old one out the opposite side. 'prev' runs it backwards. */
      if (dir && from !== i && window.innerWidth <= 640) {
        var inc = mains[i], out = mains[from];
        var back = dir === 'prev';
        void inc.offsetWidth; /* restart the animation */
        inc.classList.add('zph-slide-in');
        if (out) out.classList.add('zph-slide-out');
        if (back) {
          inc.classList.add('zph-slide-back');
          if (out) out.classList.add('zph-slide-back');
        }
      }
      thumbs.forEach(function (x, xi) { x.classList.toggle('active', xi === i); });
      /* paginate the thumb strip: once the active thumb leaves the window,
         jump a full page — forward pages start on the active thumb, backward
         pages end on it */
      var strip = thumbs[i] && thumbs[i].parentElement;
      if (strip && strip.scrollWidth > strip.clientWidth + 4) {
        var sr = strip.getBoundingClientRect(), tr = thumbs[i].getBoundingClientRect();
        var tl = tr.left - sr.left + strip.scrollLeft;
        var tright = tl + tr.width;
        if (tright > strip.scrollLeft + strip.clientWidth + 1) {
          strip.scrollTo({ left: tl - 2, behavior: 'smooth' });
        } else if (tl < strip.scrollLeft - 1) {
          strip.scrollTo({ left: Math.max(0, tright - strip.clientWidth + 2), behavior: 'smooth' });
        }
      }
      /* trust badges + Clinicians' Choice sticker belong to the hero shot only */
      root.querySelectorAll('.zph-gal-badges, .zph-frontrow-cc').forEach(function (b) {
        b.classList.toggle('zph-badges-off', i !== 0);
      });
    }
    thumbs.forEach(function (t, ti) {
      t.addEventListener('click', function () { goTo(ti, ti > galIdx ? 'next' : 'prev'); });
    });
    /* one-by-one swipe on the main image (phones) */
    var stage = mains.length ? mains[0].parentElement : null;
    if (stage) {
      var sx = 0, sy = 0, swiping = false;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!swiping) return;
        swiping = false;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          goTo(galIdx + (dx < 0 ? 1 : -1), dx < 0 ? 'next' : 'prev');
        }
      }, { passive: true });
    }

    /* plan selection */
    var subGroup = root.querySelector('.zph-subgroup');
    var otpSec = root.querySelector('.zph-otpsec');
    var otpBtn = root.querySelector('[data-otp-toggle]');
    var atcLabel = root.querySelector('[data-atc-btn-label]');
    var atcPrice = root.querySelector('[data-atc-btn-price]');
    var mbgRow = root.querySelector('[data-below-mbg]');
    var discountRow = root.querySelector('[data-below-discount]');
    var sepRow = root.querySelector('[data-below-sep]');
    var mbgStat = root.querySelector('[data-mbg-stat]');
    var current = null;
    function planEls() { return root.querySelectorAll('[data-plan]'); }
    function select(el) {
      current = el;
      planEls().forEach(function (p) {
        var on = p === el;
        p.classList.toggle('sel', on);
        var ex = p.querySelector('.zph-expand');
        /* keep-open plans (the 3-Month Results Kit) stay expanded even when
           unselected, so switching to Monthly never hides the welcome kit
           (Pietari video 2026-08-05, item 11) */
        if (ex) ex.classList.toggle('open', on || p.dataset.keepOpen === '1');
      });
      if (subGroup) subGroup.classList.toggle('hassel', el.dataset.isSub === '1');
      if (atcLabel) atcLabel.textContent = el.dataset.atcLabel || 'Add to Cart';
      if (atcPrice) atcPrice.textContent = el.dataset.atcPrice || '';
      var showMbg = el.dataset.showMbg === '1', hasDisc = el.dataset.hasDiscount === '1';
      if (mbgRow) mbgRow.style.display = showMbg ? 'inline-flex' : 'none';
      if (discountRow) discountRow.style.display = hasDisc ? 'inline-flex' : 'none';
      if (sepRow) sepRow.style.display = (showMbg && hasDisc) ? 'inline' : 'none';
      if (mbgStat) mbgStat.style.display = showMbg ? 'flex' : 'none';
      if (el.dataset.isSub === '1' && otpSec) { otpSec.classList.remove('open'); if (otpBtn) otpBtn.classList.remove('open'); }
    }
    planEls().forEach(function (p) {
      p.addEventListener('click', function (e) {
        if (e.target.closest('[data-slide-open]') || e.target.closest('.zph-trigger') || e.target.closest('.zph-info')) return;
        select(p);
      });
    });
    var featured = root.querySelector('[data-plan][data-default="1"]') || planEls()[0];
    if (featured) select(featured);
    if (otpBtn) otpBtn.addEventListener('click', function () {
      otpBtn.classList.toggle('open');
      if (otpSec) otpSec.classList.toggle('open', otpBtn.classList.contains('open'));
    });
    root.querySelectorAll('[data-switch-sub]').forEach(function (b) {
      b.addEventListener('click', function () {
        var first = root.querySelector('.zph-subgroup [data-plan]');
        if (first) { select(first); first.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      });
    });

    /* free-gift countdown, inside the green gifts panel (moved 2026-08-12).
       Four hours, held in sessionStorage so it survives navigation inside the
       session but starts fresh on a new visit. A browser that blocks storage
       falls back to a per-page-load window, which Pietari signed off on. */
    var gcds = root.querySelectorAll('[data-gift-countdown]');
    if (gcds.length) {
      var GKEY = 'zeph_gift_deadline', GWIN = 4 * 60 * 60 * 1000;
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var gdeadline = function () {
        var now = Date.now();
        try {
          var d = parseInt(sessionStorage.getItem(GKEY) || '0', 10);
          if (!d || d <= now) { d = now + GWIN; sessionStorage.setItem(GKEY, String(d)); }
          return d;
        } catch (e) {
          if (!window.__zgd || window.__zgd <= now) window.__zgd = now + GWIN;
          return window.__zgd;
        }
      };
      var gtick = function () {
        var diff = gdeadline() - Date.now(); if (diff < 0) diff = 0;
        var txt = pad(Math.floor(diff / 3600000)) + ':' + pad(Math.floor((diff % 3600000) / 60000)) + ':' + pad(Math.floor((diff % 60000) / 1000));
        gcds.forEach(function (el) { el.textContent = txt; });
      };
      gtick(); setInterval(gtick, 1000);

      /* the date is rendered client side: Shopify can serve a cached page with
         a stale Liquid date, and the shopper's own locale reads more naturally */
      root.querySelectorAll('[data-gift-date]').forEach(function (el) {
        try {
          el.textContent = new Date().toLocaleDateString(undefined, { month: 'long', day: 'numeric' });
        } catch (e) { /* keep the Liquid fallback */ }
      });
    }

    /* FAQ accordions */
    root.querySelectorAll('[data-pfaq]').forEach(function (row) {
      var head = row.querySelector('[data-pfaq-head]');
      var body = row.querySelector('[data-pfaq-body]');
      var chev = row.querySelector('svg');
      if (!head) return;
      head.addEventListener('click', function () {
        var open = body && body.style.display !== 'none';
        root.querySelectorAll('[data-pfaq]').forEach(function (r) {
          var b = r.querySelector('[data-pfaq-body]'); if (b) b.style.display = 'none';
          var c = r.querySelector('svg'); if (c) c.style.transform = 'none';
        });
        if (!open && body) { body.style.display = ''; if (chev) chev.style.transform = 'rotate(180deg)'; }
      });
    });

    /* slideouts */
    var overlay = root.querySelector('[data-slide-overlay]');
    function closeSlides() {
      if (overlay) overlay.classList.remove('open');
      root.querySelectorAll('[data-slide]').forEach(function (s) { s.classList.remove('open'); });
    }
    function openSlide(name) {
      closeSlides();
      var s = root.querySelector('[data-slide="' + name + '"]');
      if (s) { s.classList.add('open'); if (overlay) overlay.classList.add('open'); }
    }
    root.querySelectorAll('[data-slide-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); openSlide(b.dataset.slideOpen); });
    });
    root.querySelectorAll('[data-slide-close]').forEach(function (b) {
      b.addEventListener('click', closeSlides);
    });
    if (overlay) overlay.addEventListener('click', closeSlides);
    document.addEventListener('zph:open-guar', function () { openSlide('guar'); });

    /* test tabs */
    var testTabs = root.querySelectorAll('[data-test-tab]');
    var testPanels = root.querySelectorAll('[data-test-panel]');
    testTabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.dataset.testTab;
        testPanels.forEach(function (p) { p.style.display = p.dataset.testPanel === i ? '' : 'none'; });
        testTabs.forEach(function (x) {
          var on = x === t;
          x.style.background = on ? 'var(--z-purple)' : '#fff';
          x.style.color = on ? '#fff' : 'var(--z-text)';
          x.style.borderColor = on ? 'var(--z-purple)' : 'var(--z-border)';
        });
      });
    });

    /* ingredient context chips in the test slide (ported behavior from the
       live theme's lab-results modal): a chip toggles its explainer text */
    var labChips = root.querySelectorAll('[data-lab-chip]');
    var labTexts = root.querySelectorAll('[data-lab-text]');
    labChips.forEach(function (c) {
      c.addEventListener('click', function () {
        var i = c.dataset.labChip;
        var open = c.dataset.on === '1';
        labChips.forEach(function (x) {
          var on = x === c && !open;
          x.dataset.on = on ? '1' : '0';
          x.style.background = on ? 'var(--z-purple)' : '#fff';
          x.style.color = on ? '#fff' : 'var(--z-text)';
          x.style.borderColor = on ? 'var(--z-purple)' : 'var(--z-border)';
        });
        labTexts.forEach(function (p) { p.style.display = (p.dataset.labText === i && !open) ? '' : 'none'; });
      });
    });

    /* ---- add to cart -> global drawer (lives in the header) ---- */
    var atcBtn = root.querySelector('[data-atc]');
    if (atcBtn) atcBtn.addEventListener('click', function () {
      if (!current || !window.ZPHCart || atcBtn.dataset.busy) return;
      /* the cart call is two requests (clear then add), so hold a visible "Adding…"
         state until the drawer opens. Doubles as a double-click guard -- a second
         click mid-flight would clear the cart out from under the first add. */
      var sep = atcBtn.querySelector('[data-atc-btn-sep]');
      atcBtn.dataset.busy = '1';
      atcBtn.style.opacity = '.55';
      atcBtn.style.cursor = 'default';
      if (atcLabel) atcLabel.textContent = 'Adding…';
      if (sep) sep.style.display = 'none';
      if (atcPrice) atcPrice.style.display = 'none';
      function settle() {
        delete atcBtn.dataset.busy;
        atcBtn.style.opacity = '';
        atcBtn.style.cursor = 'pointer';
        if (sep) sep.style.display = '';
        if (atcPrice) atcPrice.style.display = '';
        /* re-derive rather than restore a cached string, so a plan change during
           the request still leaves the right label behind */
        if (atcLabel && current) atcLabel.textContent = current.dataset.atcLabel || 'Add to Cart';
      }
      var qty = parseInt(current.dataset.qty || '1', 10);
      window.ZPHCart.compose(current.dataset.variant || null, qty, current.dataset.planKey || null)
        .then(function () { window.ZPHCart.open(); settle(); })
        .catch(function (err) { settle(); alert((err && err.description) || 'Could not add to cart.'); });
    });
  }


  /* ---- global cart drawer (rendered by the header on every page) ---- */
  function initCartDrawer() {
    var panel = document.querySelector('[data-cart-panel]');
    if (!panel || panel.dataset.zphCartInit) return;
    panel.dataset.zphCartInit = '1';
    var ov = document.querySelector('[data-cartov]');
    var cfg = panel.dataset; // doypack, tin, plan12w, plan4w, plan24w, freeShipCents
    var freeShip = parseInt(cfg.freeShipCents || '10000', 10);
    /* Free-gift config, emitted by zph-pdp-cart.liquid from live product data.
       A gift that is Draft/unpublished is simply absent — nothing here may
       assume ring/app exist. */
    var gifts = {};
    try { gifts = JSON.parse((document.querySelector('[data-cart-gifts]') || {}).textContent || '{}'); } catch (e) { gifts = {}; }
    var dpCompare = parseInt(gifts.dpCompareCents || '7996', 10);
    /* the cart state the app gift was last re-added for -- see renderCart */
    var appRestore = null;
    function giftRole(variantId) {
      var v = String(variantId);
      if (gifts.tin && v === String(gifts.tin.variant)) return 'tin';
      if (String(v) === String(cfg.tin)) return 'tin';
      if (gifts.ring && v === String(gifts.ring.variant)) return 'ring';
      if (gifts.app && v === String(gifts.app.variant)) return 'app';
      return null;
    }
    /* compare-at cents for one line, for the strikethroughs and the savings
       total: the doypack's kit value, a gift's product compare-at, otherwise
       whatever line-level discount Shopify already reports */
    function lineCompare(it) {
      if (String(it.variant_id) === String(cfg.doypack)) return dpCompare * it.quantity;
      var role = giftRole(it.variant_id);
      if (role) {
        var meta = gifts[role];
        var per = meta && parseInt(meta.compareCents, 10) > 0 ? parseInt(meta.compareCents, 10) : 0;
        return per > 0 ? per * it.quantity : it.original_line_price;
      }
      return it.original_line_price;
    }
    function setOpen(open) {
      if (ov) ov.classList.toggle('open', open);
      panel.classList.toggle('open', open);
      if (open) refreshCart();
    }
    function resolvePlan(key) {
      if (!key || key === 'none') return null;
      if (key === '12w') return cfg.plan12w || null;
      if (key === '4w') return cfg.plan4w || null;
      if (key === '24w') return cfg.plan24w || null;
      return key; // raw numeric id
    }
    /* A cart failure body is JSON from the cart API but HTML from the throttle
       and error pages, so it can never be assumed parseable -- r.json() on the
       throttle page used to throw a SyntaxError and swallow the real reason. */
    function cartError(r) {
      return r.text().then(function (t) {
        var e = null;
        try { e = JSON.parse(t); } catch (err) { e = null; }
        if (e && (e.description || e.message)) return e;
        return { description: r.status === 429
          ? 'The cart is busy for a moment \u2014 please try that again in a few seconds.'
          : 'Could not add to cart. Please try again.' };
      }).catch(function () { return { description: 'Could not add to cart. Please try again.' }; });
    }
    /* One retry, on 429 only. The throttle clears in seconds, so a silent retry
       spares the shopper an error they can do nothing about; anything else
       fails straight through, because retrying a real error only doubles the
       load that caused it. */
    function postCart(url, body) {
      function once() {
        return fetch(url, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: body ? JSON.stringify(body) : undefined
        });
      }
      return once().then(function (r) {
        if (r.status !== 429) return r;
        return new Promise(function (res) { setTimeout(res, 1500); }).then(once);
      });
    }
    /* a cart snapshot, in the shape /cart/add.js needs to rebuild it */
    function itemsFrom(cart) {
      return (cart && cart.items ? cart.items : []).map(function (it) {
        var l = { id: it.variant_id, quantity: it.quantity };
        if (it.selling_plan_allocation) l.selling_plan = it.selling_plan_allocation.selling_plan.id;
        return l;
      });
    }
    function compose(variantOverride, qty, planKey) {
      var line = { id: parseInt(variantOverride || cfg.doypack, 10), quantity: qty };
      var plan = resolvePlan(planKey);
      if (plan) line.selling_plan = parseInt(plan, 10);
      var items = [line];
      if (cfg.tin) items.push({ id: parseInt(cfg.tin, 10), quantity: 1 });
      /* subscription gifts: one giveaway entry per pouch, app access on any
         subscription. One-time orders get the tin only. App access used to be
         gated at 3+ pouches, which left the Monthly plan without it (B6,
         2026-08-12). The gate lives in three places -- here, and the remove and
         restore passes in renderCart -- and all three have to agree. */
      if (plan) {
        if (gifts.ring) items.push({ id: parseInt(gifts.ring.variant, 10), quantity: qty });
        if (gifts.app) items.push({ id: parseInt(gifts.app.variant, 10), quantity: 1 });
      }
      /* Shopify's AJAX cart cannot swap a cart in one call, so this stays
         clear-then-add -- but the clear must never be left standing on its own.
         /cart/add.js gets throttled here often enough to matter (HTTP 429), and
         a throttled add used to leave the shopper with an emptied cart and a
         bare "Could not add to cart." Now: snapshot first, clear only when
         there is something to clear, and put the old lines back if the add
         fails. */
      var prev = [];
      return fetch('/cart.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (cart) {
          prev = itemsFrom(cart);
          /* an unreadable cart is not an empty one: clear anyway rather than
             risk adding a second set of lines on top of the shopper's */
          if (cart && !prev.length) return null;
          return postCart('/cart/clear.js').then(function (r) {
            /* the clear is the destructive half. If it did not land, stop here
               with the cart still whole instead of adding on top of it. */
            if (!r.ok) return cartError(r).then(function (e) { throw e; });
          });
        })
        .then(function () {
          var added = false;
          return postCart('/cart/add.js', { items: items })
            .then(function (r) {
              if (r.ok) { added = true; return r.json(); }
              return cartError(r).then(function (e) { throw e; });
            })
            .catch(function (e) {
              /* the lines are in; a parse hiccup after the fact is not worth
                 undoing, and the drawer redraws from /cart.js anyway */
              if (added) return null;
              if (!prev.length) throw e;
              /* the clear has already run, so put the shopper's cart back
                 before the error surfaces. This catch covers a dropped
                 connection as well as an HTTP error -- a rejected fetch used to
                 skip the restore and leave them empty-handed. */
              return postCart('/cart/add.js', { items: prev })
                .catch(function () { })
                .then(function () {
                  throw (e && e.description) ? e : { description: 'Could not add to cart. Please try again.' };
                });
            });
        });
    }
    function money(cents) { return '$' + (cents / 100).toFixed(2); }
    function renderCart(cart) {
      /* the visible count is POUCHES, not cart units — free gifts (tin, ring
         entries, app) would otherwise inflate a 3-pouch kit to "(8)". The
         empty/full switches still key off item_count: a gifts-only cart is a
         transient state the corrective pass is about to drain, and it should
         render as a cart while it still has lines. */
      var dpCount = 0;
      cart.items.forEach(function (it) {
        if (String(it.variant_id) === String(cfg.doypack)) dpCount += it.quantity;
      });
      var title = panel.querySelector('[data-cart-title]');
      if (title) title.textContent = 'Your Cart (' + dpCount + ')';
      var empty = panel.querySelector('[data-cart-empty]');
      var full = panel.querySelector('[data-cart-full]');
      if (empty) empty.style.display = cart.item_count === 0 ? 'flex' : 'none';
      if (full) full.style.display = cart.item_count === 0 ? 'none' : 'flex';
      /* gifts follow the product: no doypack, no gifts; ring entries track the
         pouch count; the app rides only on 3+ pouch subscriptions. One
         corrective cart call at a time — renderCart runs again after each, so
         this converges instead of racing itself. It only ever removes or
         shrinks: re-ADDING here could loop forever against a product that
         refuses to add (draft, out of channel). */
      var dpLine = null, giftLines = [];
      cart.items.forEach(function (it) {
        if (String(it.variant_id) === String(cfg.doypack)) dpLine = it;
        else if (giftRole(it.variant_id)) giftLines.push(it);
      });
      if (!dpLine && giftLines.length) { changeLine(giftLines[0].key, 0); return; }
      if (dpLine) {
        var planned = !!dpLine.selling_plan_allocation;
        for (var gi = 0; gi < giftLines.length; gi++) {
          var g = giftLines[gi], role = giftRole(g.variant_id);
          if (role === 'ring' && (!planned || g.quantity !== dpLine.quantity)) {
            changeLine(g.key, planned ? dpLine.quantity : 0); return;
          }
          /* app access rides on any subscription; only a switch to a one-time
             purchase strips it (B6, 2026-08-12) */
          if (role === 'app' && !planned) { changeLine(g.key, 0); return; }
        }
        /* The app is the one entitlement this pass has to be able to put back.
           Any subscription includes it, so if the line is missing -- an old cart
           built before the monthly fix, or a drawer that dropped it -- this puts
           it back. Ring quantity already re-grows the same way.
           Guarded to one attempt per cart state, so a gift that refuses to add
           (draft, out of channel) can never loop the way the removals cannot. */
        if (planned && gifts.app) {
          var hasApp = false;
          for (var gj = 0; gj < giftLines.length; gj++) {
            if (giftRole(giftLines[gj].variant_id) === 'app') hasApp = true;
          }
          if (hasApp) {
            /* it is back -- re-arm, or a shopper who steps 3-2-3 twice gets the
               gift restored the first time and not the second */
            appRestore = null;
          } else {
            var appStamp = dpLine.quantity + ':' + dpLine.selling_plan_allocation.selling_plan.id;
            if (appRestore !== appStamp) {
              appRestore = appStamp;
              addLine(parseInt(gifts.app.variant, 10), 1);
              return;
            }
          }
        }
      }
      /* product first, then the gifts in a fixed order — the doypack must
         head the drawer no matter what order the lines were added in */
      var roleRank = { tin: 1, ring: 2, app: 3 };
      var sorted = cart.items.slice().sort(function (a, b) {
        function rank(it) {
          if (String(it.variant_id) === String(cfg.doypack)) return 0;
          var r = giftRole(it.variant_id);
          return r ? roleRank[r] : 9;
        }
        return rank(a) - rank(b);
      });
      var lines = panel.querySelector('[data-cart-lines]');
      if (lines) {
        lines.innerHTML = '';
        sorted.forEach(function (it) {
          var role = giftRole(it.variant_id);
          var isTin = !!role; /* every gift renders like the tin: no stepper */
          var isDp = String(it.variant_id) === String(cfg.doypack);
          var planId = it.selling_plan_allocation ? String(it.selling_plan_allocation.selling_plan.id) : null;
          var subtitle = '';
          if (isDp) {
            var planWeeks = planId === String(cfg.plan24w) ? 24 : planId === String(cfg.plan12w) ? 12 : planId === String(cfg.plan4w) ? 4 : null;
            subtitle = (it.quantity * 4) + ' weeks supply, ' +
              (planId ? (planWeeks ? 'delivered every ' + planWeeks + ' weeks' : it.selling_plan_allocation.selling_plan.name) : 'delivered one time');
          } else if (role === 'ring') {
            subtitle = it.quantity + (it.quantity > 1 ? ' giveaway entries' : ' giveaway entry');
          } else if (it.selling_plan_allocation) {
            subtitle = it.selling_plan_allocation.selling_plan.name;
          }
          var row = document.createElement('div');
          row.style.cssText = 'display:flex;gap:14px;padding-top:16px;';
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') : '';
          /* No tile behind the image. Both product shots are cut-out PNGs, so a
             filled square read as a coloured card around a floating product;
             they sit on the drawer's own white instead. `contain` rather than
             `cover` for the same reason — with nothing to bleed to, cropping a
             cut-out only clips the product. */
          row.innerHTML =
            '<div style="width:74px;height:74px;flex:none;">' +
            (img ? '<img src="' + img + '" alt="" style="width:100%;height:100%;object-fit:contain;display:block;">' : '') + '</div>' +
            '<div style="flex:1;min-width:0;">' +
            '<div style="display:flex;justify-content:space-between;gap:10px;">' +
            '<div style="font-size:15px;font-weight:700;color:var(--z-text);line-height:1.2;">' + it.product_title + '</div>' +
            /* gifts keep the bin for visual rhythm but greyed and inert —
               they follow the product line, they are not removable on their
               own (and the corrective pass would fight a partial state) */
            (role
              ? '<button type="button" class="zph-cart-x" disabled aria-label="Included free with your order" title="Included free with your order" style="opacity:.3;cursor:default;pointer-events:none;"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path></svg></button>'
              : '<button type="button" class="zph-cart-x" data-line-remove="' + it.key + '" aria-label="Remove"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path></svg></button>') + '</div>' +
            (it.variant_title && it.variant_title !== 'Default Title' ? '<div style="font-size:12.5px;color:var(--z-muted);margin-top:3px;">' + it.variant_title + '</div>' : '') +
            (subtitle ? '<div style="font-size:12.5px;color:var(--z-muted);margin-top:3px;">' + subtitle + '</div>' : '') +
            '<div style="display:flex;align-items:baseline;gap:8px;margin-top:8px;">' +
            '<span style="font-size:15px;font-weight:700;color:var(--z-text);">' + (it.final_line_price === 0 ? '<span style="color:#2f7d3e;">FREE</span>' : money(it.final_line_price)) + '</span>' +
            (lineCompare(it) > it.final_line_price ? '<span style="font-size:12.5px;color:#a99fb4;text-decoration:line-through;">' + money(lineCompare(it)) + '</span>' : '') + '</div>' +
            (isTin ? '' :
            '<div style="margin-top:11px;"><div class="zph-cart-step">' +
            '<button type="button" data-line-dec="' + it.key + '" data-line-qty="' + it.quantity + '"' + (isDp && planId ? ' data-line-replan="1"' : '') + ' aria-label="Decrease">&minus;</button>' +
            '<span style="min-width:34px;text-align:center;font-size:14px;font-weight:600;color:var(--z-text);">' + it.quantity + '</span>' +
            '<button type="button" data-line-inc="' + it.key + '" data-line-qty="' + it.quantity + '"' + (isDp && planId ? ' data-line-replan="1"' : '') + ' aria-label="Increase">+</button></div></div>') + '</div>';
          lines.appendChild(row);
        });
        lines.querySelectorAll('[data-line-remove]').forEach(function (b) {
          b.addEventListener('click', function () {
            /* same in-place spinner as the steppers; changeLine restores the
               bin via unspin if the request fails, and a success rebuilds the
               rows so there is nothing to restore */
            if (!spin(b)) return;
            changeLine(b.dataset.lineRemove, 0, null, b);
          });
        });
        /* subscription lines re-plan with quantity: 6+ pouches = 24w plan, 3-5 = 12w, 1-2 = 4w */
        function planForQty(q) { return q >= 6 ? cfg.plan24w : q >= 3 ? cfg.plan12w : cfg.plan4w; }
        lines.querySelectorAll('[data-line-dec]').forEach(function (b) {
          b.addEventListener('click', function () {
            if (!spin(b)) return;
            var q = Math.max(0, parseInt(b.dataset.lineQty, 10) - 1);
            changeLine(b.dataset.lineDec, q, q > 0 && b.dataset.lineReplan === '1' ? planForQty(q) : null, b);
          });
        });
        lines.querySelectorAll('[data-line-inc]').forEach(function (b) {
          b.addEventListener('click', function () {
            if (!spin(b)) return;
            var q = parseInt(b.dataset.lineQty, 10) + 1;
            changeLine(b.dataset.lineInc, q, b.dataset.lineReplan === '1' ? planForQty(q) : null, b);
          });
        });
      }
      var sub = panel.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = money(cart.items_subtotal_price);
      var cmpEl = panel.querySelector('[data-cart-compare]');
      var pctEl = panel.querySelector('[data-cart-pct]');
      /* the struck-through total is the sum of every line's VALUE — kit
         compare-at plus each gift's compare-at — so the free gifts push the
         saving up, Gruns-style, not just Shopify's own discounts */
      var compareTotal = 0;
      cart.items.forEach(function (it) { compareTotal += lineCompare(it); });
      var orig = Math.max(cart.original_total_price || 0, compareTotal, cart.items_subtotal_price);
      var hasCmp = orig > cart.items_subtotal_price;
      if (cmpEl) { cmpEl.style.display = hasCmp ? '' : 'none'; cmpEl.textContent = hasCmp ? money(orig) : ''; }
      if (pctEl) {
        pctEl.style.display = hasCmp ? '' : 'none';
        if (hasCmp) pctEl.textContent = Math.round((1 - cart.items_subtotal_price / orig) * 100) + '% Off';
      }
      var discBanner = panel.querySelector('[data-cart-discount-banner]');
      if (discBanner) discBanner.style.display = hasCmp ? '' : 'none';
      var shipMsg = panel.querySelector('[data-ship-msg]');
      var shipBar = panel.querySelector('[data-ship-bar]');
      var earned = cart.items_subtotal_price >= freeShip;
      if (shipMsg) shipMsg.innerHTML = earned ? 'Congratulations! You\u2019ve earned FREE shipping!' : ('You\u2019re ' + money(freeShip - cart.items_subtotal_price) + ' away from FREE SHIPPING!');
      if (shipBar) shipBar.style.width = (earned ? 100 : Math.round(cart.items_subtotal_price / freeShip * 100)) + '%';
      document.querySelectorAll('.zph-cart-label').forEach(function (l) {
        l.textContent = 'Cart' + (dpCount > 0 ? ' (' + dpCount + ')' : '');
      });
      /* 3-month kit sub OR a one-time 6-pack -> pitch the 6-month/24w kit;
         on the 6-month sub -> none; else pitch the 3-month kit */
      var dp = dpLine;
      var up3 = panel.querySelector('[data-upsell-target="sub3"]');
      var up6 = panel.querySelector('[data-upsell-target="sub6"]');
      if (up3 || up6) {
        var hasPlan = !!(dp && dp.selling_plan_allocation);
        var onSixKit = hasPlan && dp.quantity >= 6;
        var onThreeKit = hasPlan && dp.quantity >= 3 && !onSixKit;
        var oneTimeSix = !!dp && !hasPlan && dp.quantity >= 6;
        if (up6) up6.style.display = (onThreeKit || oneTimeSix) ? '' : 'none';
        if (up3) up3.style.display = (!onThreeKit && !onSixKit && !oneTimeSix && cart.item_count > 0) ? '' : 'none';
      }
      document.querySelectorAll('.zph-cart').forEach(function (c) { c.classList.toggle('zph-cart-empty', cart.item_count === 0); });
    }
    /* One retry on 429, same deal as postCart. This read is what paints the
       drawer, so a throttled one is not a harmless miss. */
    function getCart() {
      function once() { return fetch('/cart.js', { headers: { 'Cache-Control': 'no-cache' } }); }
      return once().then(function (r) {
        if (r.status !== 429) return r;
        return new Promise(function (res) { setTimeout(res, 1500); }).then(once);
      });
    }
    /* A failed read used to be swallowed whole, leaving the drawer showing its
       full shell with no lines and no subtotal -- indistinguishable from an
       empty cart the shopper never emptied. Say so, and give them the retry. */
    function showCartUnread() {
      var lines = panel.querySelector('[data-cart-lines]');
      /* stale rows beat a wiped panel: only speak up when there is nothing */
      if (!lines || lines.children.length) return;
      lines.innerHTML = '<div style="padding:18px 0;text-align:center;font-size:13px;color:var(--z-muted);">' +
        'We couldn\u2019t load your cart just now. ' +
        '<button type="button" data-cart-retry style="border:none;background:none;padding:0;font:inherit;' +
        'color:var(--z-purple);font-weight:700;text-decoration:underline;cursor:pointer;">Try again</button></div>';
      var b = lines.querySelector('[data-cart-retry]');
      if (b) b.addEventListener('click', function () { lines.innerHTML = ''; refreshCart(); });
    }
    function refreshCart() {
      /* returns the promise so callers can hold a loading state until the redraw */
      return getCart().then(function (r) {
        if (!r.ok) throw new Error('cart read failed');
        return r.json();
      }).then(renderCart).catch(function () { showCartUnread(); });
    }
    /* swap a control's contents for a loading circle; on success renderCart rebuilds
       the row so there is nothing to restore, hence the undo only for failures */
    function spin(btn) {
      if (!btn || btn.dataset.busy) return false;
      btn.dataset.busy = '1';
      btn.dataset.was = btn.innerHTML;
      btn.innerHTML = '<span class="zph-spin"></span>';
      btn.style.pointerEvents = 'none';
      return true;
    }
    function unspin(btn) {
      if (!btn || !btn.dataset.busy) return;
      btn.innerHTML = btn.dataset.was || '';
      btn.style.pointerEvents = '';
      delete btn.dataset.busy;
      delete btn.dataset.was;
    }
    /* the corrective pass's one additive move -- see the app note in renderCart.
       add.js answers with the added lines rather than the cart, so the redraw
       comes from /cart.js either way. */
    function addLine(id, quantity) {
      postCart('/cart/add.js', { items: [{ id: id, quantity: quantity }] })
        .then(function () { refreshCart(); })
        .catch(function () { refreshCart(); });
    }
    function changeLine(key, qty, sellingPlan, btn) {
      var body = { id: key, quantity: qty };
      if (sellingPlan) body.selling_plan = parseInt(sellingPlan, 10);
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(renderCart)
        .catch(function () { unspin(btn); });
    }
    panel.querySelectorAll('[data-cart-close]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(false); });
    });
    if (ov) ov.addEventListener('click', function () { setOpen(false); });
    /* the header cart link opens the drawer on every page */
    document.querySelectorAll('a.zph-cart, [data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); setOpen(true); });
    });
    var checkout = panel.querySelector('[data-checkout]');
    if (checkout) checkout.addEventListener('click', function () {
      /* the navigation can take a moment; spin in place of the words and keep the
         padlock. No restore -- we are leaving the page. */
      if (checkout.dataset.busy) return;
      checkout.dataset.busy = '1';
      var clab = checkout.querySelector('[data-checkout-label]');
      if (clab) clab.innerHTML = '<span class="zph-spin"></span>';
      window.location.href = '/checkout';
    });
    var emptyTile = panel.querySelector('[data-cart-empty-tile]');
    if (emptyTile) emptyTile.addEventListener('click', function (e) {
      var here = window.location.pathname.replace(/\/$/, '');
      var dest = (emptyTile.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
      if (dest === '' || here === dest) { e.preventDefault(); setOpen(false); }
    });
    panel.querySelectorAll('[data-upsell-add]').forEach(function (upBtn) {
      upBtn.addEventListener('click', function () {
        /* same treatment as the buy button: fade to "Adding…" while clear+add run,
           which also stops a second click clearing the cart mid-add */
        if (upBtn.dataset.busy) return;
        var wasText = upBtn.textContent;
        upBtn.dataset.busy = '1';
        upBtn.style.opacity = '.55';
        upBtn.style.cursor = 'default';
        upBtn.textContent = 'Adding…';
        function settle() {
          delete upBtn.dataset.busy;
          upBtn.style.opacity = '';
          upBtn.style.cursor = 'pointer';
          upBtn.textContent = wasText;
        }
        var qty = parseInt(upBtn.dataset.qty || '1', 10);
        compose(upBtn.dataset.variant || null, qty, upBtn.dataset.sellingPlan || upBtn.dataset.planKey || null)
          .then(function () { return refreshCart(); })
          .then(settle).catch(settle);
      });
    });
    window.ZPHCart = { open: function () { setOpen(true); }, close: function () { setOpen(false); }, compose: compose, refresh: refreshCart };
    refreshCart();
  }

  /* ---- transformation timeline ---- */
  function initTimeline(root) {
    var track = root.querySelector('[data-ztl-track]');
    var fill = root.querySelector('[data-ztl-fill]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ztl-item]'));
    var sides = Array.prototype.slice.call(root.querySelectorAll('.ztl-side')).map(function (el) {
      return {
        el: el,
        flip: el.dataset.flip === '1',
        dx: parseFloat(el.dataset.dx || '0'),
        drot: parseFloat(el.dataset.drot || '0'),
        ox: parseFloat(el.dataset.x || '0'),
        oy: parseFloat(el.dataset.y || '0'),
        sc: parseFloat(el.dataset.scale || '1'),
        rot: parseFloat(el.dataset.rot || '0')
      };
    });
    if (reduce()) {
      if (fill) fill.style.height = '100%';
      items.forEach(function (li) { li.setAttribute('data-on', ''); });
      sides.forEach(function (s) {
        s.el.style.opacity = '1';
        s.el.style.transform = 'translate(' + s.ox + 'px,' + s.oy + 'px) rotate(' + s.rot + 'deg) scale(' + (s.flip ? -s.sc : s.sc) + ',' + s.sc + ')';
      });
      return;
    }
    function tick() {
      var vh = window.innerHeight || 800;
      if (track && fill) {
        var rect = track.getBoundingClientRect();
        var start = vh * 0.72, end = vh * 0.34;
        var total = rect.height + (start - end);
        var p = Math.max(0, Math.min(1, (start - rect.top) / total));
        fill.style.height = (p * 100) + '%';
        var filledPx = p * rect.height;
        items.forEach(function (li) {
          var r = li.getBoundingClientRect();
          var markerY = r.top + 22 + 17 - rect.top;
          if (filledPx >= markerY - 8) li.setAttribute('data-on', '');
          else li.removeAttribute('data-on');
        });
      }
      if (sides.length) {
        var secTop = root.getBoundingClientRect().top;
        var c1 = 1.70158, c3 = c1 + 1;
        sides.forEach(function (s) {
          var cen = secTop + s.el.offsetTop + s.el.offsetHeight / 2;
          var t = (vh * 0.92 - cen) / (vh * 0.40);
          t = t < 0 ? 0 : (t > 1 ? 1 : t);
          var eb = 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
          var op = t * t * (3 - 2 * t);
          var dx = s.ox + s.dx * (1 - eb);
          var dy = s.oy + 60 * (1 - eb) - 34 * Math.sin(t * Math.PI);
          var rot = s.rot + s.drot * (1 - eb);
          s.el.style.opacity = op.toFixed(3);
          s.el.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px) rotate(' + rot.toFixed(2) + 'deg) scale(' + (s.flip ? -s.sc : s.sc) + ',' + s.sc + ')';
        });
      }
    }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick, { passive: true });
    sides.forEach(function (s) { s.el.addEventListener('load', tick); });
    tick();
    setTimeout(tick, 300);
  }

  function initGuarBand(root) {
    root.querySelectorAll('[data-open-guar-global]').forEach(function (b) {
      b.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('zph:open-guar'));
      });
    });
  }

  /* ---- before/after drag sliders ---- */
  function initBaCards() {
    document.querySelectorAll('[data-ba-card]').forEach(function (card) {
      if (card.dataset.zphBaInit) return;
      card.dataset.zphBaInit = '1';
      var top = card.querySelector('[data-ba-topwrap]');
      var handle = card.querySelector('[data-ba-handle]');
      function setPos(clientX) {
        var r = card.getBoundingClientRect();
        var p = (clientX - r.left) / r.width * 100;
        if (p < 4) p = 4; if (p > 96) p = 96;
        top.style.clipPath = 'inset(0 0 0 ' + p.toFixed(2) + '%)';
        handle.style.left = p.toFixed(2) + '%';
      }
      /* down  = a pointer is on the card
         armed = we own the gesture, so pointermove drives the divider
         On the photo, a touch is ambiguous — it could be a compare drag or someone
         scrolling past — so we stay unarmed until the movement is clearly sideways
         and let the browser pan vertically until then (touch-action:pan-y on the
         card). Arming on pointerdown instead is what made a vertical drag both
         teleport the divider AND scroll the page. The handle is touch-action:none,
         so grabbing it arms instantly and can never turn into a scroll. A mouse is
         unambiguous and keeps the old jump-to-click. */
      var down = false, armed = false, moved = false, startX = 0, startY = 0;
      /* the slider area is for comparing, not for opening the popup —
         clicks on the rest of the tile still open it */
      card.addEventListener('click', function (e) {
        e.stopPropagation();
        if (moved) { e.preventDefault(); moved = false; }
      }, true);
      ['touchstart', 'touchmove'].forEach(function (ev) {
        card.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true });
      });
      function arm(e) {
        armed = true;
        try { card.setPointerCapture(e.pointerId); } catch (err) { }
      }
      card.addEventListener('pointerdown', function (e) {
        down = true; moved = false; startX = e.clientX; startY = e.clientY;
        armed = false;
        var onHandle = !!(e.target && e.target.closest && e.target.closest('[data-ba-handle]'));
        if (e.pointerType === 'mouse' || onHandle) { arm(e); setPos(e.clientX); }
      });
      card.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!armed) {
          /* vertical intent wins: hand the gesture back and stay out of the way */
          if (Math.abs(e.clientY - startY) > Math.abs(dx)) { down = false; return; }
          if (Math.abs(dx) < 6) return;
          arm(e);
        }
        if (Math.abs(dx) > 6) moved = true;
        setPos(e.clientX);
      });
      card.addEventListener('pointerup', function (e) {
        /* a clean tap still snaps the divider to where you tapped */
        if (down && !moved) setPos(e.clientX);
        down = false; armed = false;
      });
      card.addEventListener('pointercancel', function () { down = false; armed = false; });
    });
  }

  function initAll() {
    initCartDrawer();
    initBaCards();
    document.querySelectorAll('[data-zph-pdp]').forEach(function (r) {
      if (!r.dataset.zphPdpInit) { r.dataset.zphPdpInit = '1'; try { initPdp(r); } catch (e) { if (window.console) console.error('zph pdp', e); } }
    });
    document.querySelectorAll('[data-zph-timeline]').forEach(function (r) {
      if (!r.dataset.zphTlInit) { r.dataset.zphTlInit = '1'; try { initTimeline(r); } catch (e) { if (window.console) console.error('zph tl', e); } }
    });
    document.querySelectorAll('[data-zph-guarband]').forEach(function (r) {
      if (!r.dataset.zphGbInit) { r.dataset.zphGbInit = '1'; initGuarBand(r); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function () { setTimeout(initAll, 50); });
})();

/* ============ Page utilities: parallax, pie, accordion ============ */
(function () {
  'use strict';
  if (window.__ZPH_PAGES__) return;
  window.__ZPH_PAGES__ = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* parallax */
  function parallaxTick() {
    var vh = window.innerHeight || 800;
    document.querySelectorAll('.zph-parallax').forEach(function (el) {
      var wrap = el.parentElement;
      if (!wrap) return;
      var r = wrap.getBoundingClientRect();
      if (r.bottom < -300 || r.top > vh + 300) return;
      var sp = parseFloat(el.dataset.parallax) || 0.15;
      var center = r.top + r.height / 2 - vh / 2;
      el.style.transform = 'translate3d(0,' + (-center * sp).toFixed(1) + 'px,0)';
    });
  }

  /* pie chart */
  function pieAt(f) {
    if (f <= 0) return 'M18 18 Z';
    if (f >= 1) f = 0.9999;
    var a = -f * 2 * Math.PI;
    var x = (18 + 16 * Math.sin(a)).toFixed(3);
    var y = (18 - 16 * Math.cos(a)).toFixed(3);
    var large = f > 0.5 ? 1 : 0;
    return 'M18 18 L18 2 A16 16 0 ' + large + ' 0 ' + x + ' ' + y + ' Z';
  }
  var piesDone = {};
  function pieTick() {
    document.querySelectorAll('[data-zph-pie]').forEach(function (path, idx) {
      if (piesDone[idx]) return;
      var vh = window.innerHeight || 800;
      var r = path.getBoundingClientRect();
      if (r.top > vh * 0.85) return;
      piesDone[idx] = true;
      var target = (parseFloat(path.dataset.zphPie) || 76) / 100;
      if (reduce) { path.setAttribute('d', pieAt(target)); return; }
      var dur = 2600;
      var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
      var t0 = performance.now();
      var tick = function () {
        var t = (performance.now() - t0) / dur;
        if (t > 1) t = 1;
        path.setAttribute('d', pieAt(target * ease(t)));
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  }

  /* plus accordion (fake brands "real thing") */
  function initAccordions() {
    document.querySelectorAll('[data-zph-acc]').forEach(function (root) {
      if (root.dataset.zphAccInit) return;
      root.dataset.zphAccInit = '1';
      var rows = root.querySelectorAll('[data-acc-row]');
      rows.forEach(function (row) {
        var btn = row.querySelector('[data-acc-btn]');
        var body = row.querySelector('[data-acc-body]');
        var arrow = row.querySelector('[data-acc-arrow]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var isOpen = row.dataset.open === '1';
          rows.forEach(function (r) {
            r.dataset.open = '0';
            var b = r.querySelector('[data-acc-body]');
            var a = r.querySelector('[data-acc-arrow]');
            if (b) { b.style.maxHeight = '0'; b.style.opacity = '0'; }
            if (a) { a.style.transform = 'rotate(0deg)'; a.style.borderColor = 'rgba(255,255,255,0.3)'; }
          });
          if (!isOpen) {
            row.dataset.open = '1';
            if (body) { body.style.maxHeight = '240px'; body.style.opacity = '1'; }
            if (arrow) { arrow.style.transform = 'rotate(135deg)'; arrow.style.borderColor = 'var(--z-purple)'; }
          }
        });
      });
    });
  }

  /* same treatment as the main runtime: one binding, rAF-coalesced. Both of these
     do a document-wide querySelectorAll on every call, and on the homepage
     .zph-parallax matches nothing at all, so this was pure cost twice a scroll. */
  var utilRaf = 0;
  function runUtil() { utilRaf = 0; parallaxTick(); pieTick(); }
  function onScroll() {
    if (utilRaf) return;
    utilRaf = requestAnimationFrame(runUtil);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  function boot() { initAccordions(); onScroll(); setTimeout(onScroll, 300); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 50); });
})();

/* ============ Ambient video power saver ============
   Background loop videos (hero, pill) pause when offscreen, when the tab
   is hidden, or when the window loses focus; resume when visible again. */
(function () {
  'use strict';
  if (window.__ZPH_VIDPAUSE__) return;
  window.__ZPH_VIDPAUSE__ = true;

  function videos() {
    return document.querySelectorAll('[data-zph="hero"] video, [data-pill-video]');
  }
  function inView(el) {
    /* A video driving a canvas compositor is deliberately shrunk to a pixel, or
       hidden outright, so that the shader can present its frames instead. Its
       own rect is therefore meaningless — measuring it reports offscreen for
       ever and this saver pauses the very clip the canvas is drawing. That is
       exactly how the pill kept stopping about six seconds in, on the first
       scroll after it started. Judge these by the canvas the visitor is
       actually looking at. */
    var target = el;
    if (el.classList && el.classList.contains('zd-media--driver')) {
      var host = el.closest && el.closest('[data-pill-matte]');
      var canvas = host && host.querySelector('canvas[data-pill-canvas]');
      if (canvas) target = canvas;
    }
    var r = target.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    return r.bottom > 0 && r.top < vh;
  }
  function update() {
    var hiddenPage = document.hidden || document.visibilityState === 'hidden' || window.__zphBlurred;
    videos().forEach(function (v) {
      var shouldPlay = !hiddenPage && inView(v);
      if (shouldPlay && v.paused) {
        var p = v.play();
        if (p && p.catch) p.catch(function () { });
      } else if (!shouldPlay && !v.paused) {
        v.pause();
      }
    });
  }
  var t = null;
  function schedule() {
    if (t) return;
    t = setTimeout(function () { t = null; update(); }, 120);
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('visibilitychange', update);
  window.addEventListener('blur', function () { window.__zphBlurred = true; update(); });
  window.addEventListener('focus', function () { window.__zphBlurred = false; update(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
  setTimeout(update, 500);
  document.addEventListener('shopify:section:load', function () { setTimeout(update, 100); });
})();

/* ============ Page scroll lock for floating panels ============
   The page must not move while a modal / slideout / drawer is open. Panels are
   opened by half a dozen independent code paths (this file's home + PDP runtimes,
   the cart drawer, and the inline scripts in zph-expert and friends), so instead
   of teaching every open()/close() to lock the page we watch the panels
   themselves: whenever one becomes visible the document freezes, and when the
   last one closes it thaws at the exact offset it left off.

   Together with `overscroll-behavior:contain` on the inner scrollers (see
   zph-home.css) this covers both ways the page used to leak: a drag on the
   backdrop or on non-scrolling panel chrome, and a scroll that runs off the end
   of the panel's own content and chains into the document. */
(function () {
  'use strict';
  if (window.__ZPH_LOCK__) return;
  window.__ZPH_LOCK__ = true;

  /* every panel that should freeze the page while it is up */
  var SEL = '.zph-modal-overlay,.zph-slide,.zph-menu,.zph-cart-panel,.zph-cart-drawer,[data-rainy-modal]';
  var CLASS = 'zph-scrolllock';
  var locked = false, y = 0, padWas = '';
  var panels = [], obs = null;

  function isOpen(el) {
    /* display-toggled overlays and class-toggled drawers, in one test */
    if (!el.isConnected) return false;
    if (el.classList.contains('zph-modal-overlay')) return el.style.display === 'flex';
    /* The Rainy modal was setting documentElement.style.overflow itself — the
       approach the comment in zph-home.css.liquid explains does not hold on iOS,
       where the page keeps scrolling behind the overlay. It toggles display
       block/none rather than a class, hence its own test here. */
    if (el.hasAttribute('data-rainy-modal')) return el.style.display === 'block';
    return el.classList.contains('open');
  }

  function setLocked(on) {
    if (on === locked) return;
    locked = on;
    var b = document.body, h = document.documentElement;
    if (on) {
      y = window.pageYOffset || h.scrollTop || 0;
      /* measure before the class hides the scrollbar */
      var sb = window.innerWidth - h.clientWidth;
      padWas = b.style.paddingRight;
      if (sb > 0) b.style.paddingRight = sb + 'px';
      b.style.top = (-y) + 'px';
      h.classList.add(CLASS);
    } else {
      h.classList.remove(CLASS);
      b.style.top = '';
      b.style.paddingRight = padWas;
      /* zph-home.css sets html{scroll-behavior:smooth}, which would ANIMATE this
         restore from 0 back to where the reader was — pinning the body parks the
         document at 0. Force the jump, then hand smooth scrolling back. */
      var sbWas = h.style.scrollBehavior;
      h.style.scrollBehavior = 'auto';
      window.scrollTo(0, y);
      h.style.scrollBehavior = sbWas;
    }
  }

  function evaluate() {
    for (var i = 0; i < panels.length; i++) {
      if (isOpen(panels[i])) { setLocked(true); return; }
    }
    setLocked(false);
  }
  /* MutationObserver already batches every attribute change made in one task into
     a single callback, so this needs no rAF/timer of its own — and staying off rAF
     means it still works in a backgrounded tab, where rAF never fires. */
  function collect() {
    if (!obs) obs = new MutationObserver(evaluate);
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.__zphLockWatched) return;
      el.__zphLockWatched = true;
      panels.push(el);
      /* observing each panel directly — not the subtree — keeps this off the hot
         path of the scroll-driven class changes happening all over the page */
      obs.observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
    });
    evaluate();
  }

  /* Esc closes nothing here; sections own that. This only reacts to state. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collect);
  else collect();
  document.addEventListener('shopify:section:load', function () { setTimeout(collect, 60); });
  /* theme-editor section removal can strip an open panel without a mutation on it */
  document.addEventListener('shopify:section:unload', function () { setTimeout(evaluate, 60); });
})();

/* ---------- Keyboard access for the custom controls ----------
   Two gaps this closes, both page-wide so no section has to opt in.

   1. Several controls are div/span rather than <button> — the diet food cards
      and their prev/next/close, the guarantee accordion rows, the review cards.
      Most of the theme's controls already ARE buttons; these are the ones that
      are not, and they were mouse-only: no focus, no Enter, no Space.

   2. Nothing anywhere closed a panel on Escape. Once a modal, drawer, menu or
      slide-over was open, a keyboard user had to tab to the X. Every one of
      these panels already has a close control, so Escape just presses it.

   Deliberately delegated rather than per-section: sections re-render in the
   theme editor and any listener bound at init is lost, while a document-level
   handler survives. Both handlers exit on the first character of the check for
   the overwhelming majority of keystrokes. */
(function () {
  if (window.__ZPH_A11Y__) return;
  window.__ZPH_A11Y__ = true;

  var NATIVE = /^(BUTTON|A|INPUT|TEXTAREA|SELECT)$/;

  /* Enter and Space on anything marked role="button" that isn't already a
     natively activatable element. Space is preventDefault'd because its default
     is to scroll the page, which would fire the control and jump the view. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var t = e.target;
    if (!t || !t.getAttribute || t.getAttribute('role') !== 'button') return;
    if (NATIVE.test(t.tagName)) return;
    e.preventDefault();
    if (t.click) t.click();
  });

  /* Panels, in the order Escape should reach them: the innermost thing a
     visitor can have open comes first, so Escape inside a slide-over on top of
     the cart closes the slide-over and leaves the cart up. */
  var PANELS = [
    ['.zph-slide.open', '[data-slide-close]'],
    ['[data-rainy-modal]', '[data-rainy-close]'],
    ['.zph-modal-overlay', '[data-review-close],[data-diet-close],[data-dr-close]'],
    ['.zph-cart-panel.open,.zph-cart-drawer.open', '[data-cart-close]'],
    ['.zph-menu.open', '[data-menu-close]']
  ];

  function shown(el) {
    if (!el || !el.isConnected) return false;
    var d = el.style.display;
    if (d === 'none') return false;
    if (el.classList.contains('zph-modal-overlay')) return d === 'flex';
    if (el.hasAttribute('data-rainy-modal')) return d === 'block';
    return true; /* the rest are matched by .open in the selector itself */
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    for (var i = 0; i < PANELS.length; i++) {
      var els = document.querySelectorAll(PANELS[i][0]);
      for (var j = 0; j < els.length; j++) {
        if (!shown(els[j])) continue;
        /* prefer a close control inside the panel; fall back to a global one,
           which is how the menu and cart are wired */
        var btn = els[j].querySelector(PANELS[i][1]) || document.querySelector(PANELS[i][1]);
        if (btn && btn.click) { e.preventDefault(); btn.click(); return; }
      }
    }
  });

  /* A closed drawer is still in the tab order: focus walks into links the
     visitor cannot see and the page appears to scroll on its own. inert takes
     the whole subtree out of the tab order and out of the accessibility tree,
     and is ignored by browsers that do not support it. */
  function syncInert() {
    document.querySelectorAll('.zph-menu,.zph-cart-panel,.zph-cart-drawer').forEach(function (el) {
      var open = el.classList.contains('open');
      if (open) el.removeAttribute('inert');
      else el.setAttribute('inert', '');
    });
  }
  function watch() {
    syncInert();
    var els = document.querySelectorAll('.zph-menu,.zph-cart-panel,.zph-cart-drawer');
    if (!els.length || !window.MutationObserver) return;
    var mo = new MutationObserver(syncInert);
    els.forEach(function (el) { mo.observe(el, { attributes: true, attributeFilter: ['class'] }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('shopify:section:load', function () { setTimeout(watch, 60); });
})();

/* ---------- Transparent pill for Safari ----------
   The pill ships as a VP9 WebM with an alpha channel, and Safari has never
   supported alpha in WebM — so iOS was handed a still image and the pill did
   not animate there at all. H.264 cannot carry alpha either, and Adobe will
   only export HEVC-with-alpha on macOS, so neither of the obvious routes was
   open on this project.

   What is open: After Effects can export the colour and the alpha as two
   ordinary H.264 files. Stacked into one clip — colour on top, matte below —
   that is 1.19MB, smaller than the 1.88MB WebM, and one decode rather than two.

   Recombining a luma matte needs the matte's brightness to become the alpha
   channel. In 2D canvas that means walking 1.17 million pixels every frame,
   which is precisely the kind of main-thread work this file has been spending
   the week removing. A fragment shader does the same thing in one GPU draw and
   costs the main thread a texture upload.

   The colour half is composited on black, which is premultiplied alpha by
   definition, so the context is created premultiplied and the shader can emit
   vec4(colour, matte) directly with no divide.

   Everything else keeps the WebM. This runs only where the WebM cannot. */
(function () {
  if (window.__ZPH_PILL__) return;
  window.__ZPH_PILL__ = true;

  var VERT = 'attribute vec2 p;varying vec2 v;void main(){v=vec2((p.x+1.0)*0.5,(1.0-p.y)*0.5);gl_Position=vec4(p,0.0,1.0);}';
  var FRAG = 'precision mediump float;varying vec2 v;uniform sampler2D t;' +
             'void main(){vec3 c=texture2D(t,vec2(v.x,v.y*0.5)).rgb;' +
             'float a=texture2D(t,vec2(v.x,v.y*0.5+0.5)).r;gl_FragColor=vec4(c,a);}';

  function compile(gl, type, src) {
    var s = gl.createShader(type);
    gl.shaderSource(s, src); gl.compileShader(s);
    return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null;
  }

  function start(video, canvas, host) {
    var gl = canvas.getContext('webgl', { alpha: true, premultipliedAlpha: true, antialias: false, depth: false });
    if (!gl) return false;
    var vs = compile(gl, gl.VERTEX_SHADER, VERT), fs = compile(gl, gl.FRAGMENT_SHADER, FRAG);
    if (!vs || !fs) return false;
    var prog = gl.createProgram();
    gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return false;
    gl.useProgram(prog);

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 1,-1, -1,1, 1,1]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, 'p');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

    var tex = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

    /* The source is 24fps and 810x1620. Driving the upload from rAF re-uploaded
       that texture 60 times a second — roughly 5MB a go, of which 36 uploads in
       every 60 pushed a frame the decoder had not changed. That waste lands in
       the same section as the step reel and competes for exactly the frames it
       needs. requestVideoFrameCallback fires once per decoded frame instead, so
       the upload happens only when there is something new to upload; the
       currentTime check gets the same saving where rVFC is missing, and also
       covers a paused-but-visible video, which rVFC cannot report on at all. */
    var sized = false, raf = 0, rvfc = 0, visible = true, lastT = -1;
    var RVFC = typeof video.requestVideoFrameCallback === 'function';
    function frame() {
      raf = 0; rvfc = 0;
      /* Nothing reschedules while off screen — the observer restarts the loop.
         The old code kept a rAF running forever behind a `visible` check. */
      if (!visible) return;
      if (video.readyState < 2) { raf = requestAnimationFrame(frame); return; }
      if (video.currentTime === lastT) { schedule(); return; }
      lastT = video.currentTime;
      if (!sized && video.videoWidth) {
        /* The source is colour above matte, so the visible canvas is half its
           height. Size from the declared source width rather than videoWidth:
           the driving video is shrunk to a pixel so the shader can present its
           frames, and WebKit reports a decode surface scaled to that, not the
           810 the file actually is. Trusting videoWidth there gave a 242px
           canvas stretched across 726 device pixels on a 3x phone. */
        var w = parseInt(host.getAttribute('data-pill-size'), 10) || video.videoWidth;
        canvas.width = w;
        canvas.height = w;
        gl.viewport(0, 0, canvas.width, canvas.height);
        sized = true;
      }
      try {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      } catch (e) { }
      schedule();
    }
    function schedule() {
      if (raf || rvfc) return;
      if (RVFC && !video.paused && video.readyState >= 2) rvfc = video.requestVideoFrameCallback(frame);
      else raf = requestAnimationFrame(frame);
    }

    /* Parked when off screen: a rAF loop uploading a texture every frame for a
       decorative loop nobody is looking at is the same waste as any other
       always-running animation on this page.

       Two things here are deliberate and were both learned the hard way. The
       observer is held on a variable rather than left anonymous, because an
       IntersectionObserver with no reference to it is collectable. And it never
       pauses before it has seen the element visible at least once — an observer
       attached a frame too early reports "not intersecting", and pausing on
       that first callback stops the very video the loop exists to drive. Only a
       transition from seen-visible to not-visible is a real departure. */
    var seen = false, io = null;
    if (window.IntersectionObserver) {
      io = new IntersectionObserver(function (es) {
        var now = es.some(function (e) { return e.isIntersecting; });
        if (now) {
          seen = true; visible = true;
          var q = video.play(); if (q && q.catch) q.catch(function () { });
          schedule();
        } else if (seen) {
          visible = false;
          try { video.pause(); } catch (e) { }
        }
      }, { rootMargin: '200px 0px' });
      io.observe(canvas);
    }
    /* start playing regardless — if the observer never fires, a running loop is
       a far better failure than a permanently frozen one */
    var p0 = video.play(); if (p0 && p0.catch) p0.catch(function () { });
    schedule();
    return true;
  }

  function init() {
    var ua = navigator.userAgent;
    var isSafari = /Safari/.test(ua) && !/Chrome|Chromium|Edg|OPR|Android/.test(ua);
    if (!isSafari) return;
    var hosts = document.querySelectorAll('[data-pill-matte]');
    for (var i = 0; i < hosts.length; i++) {
      (function (host) {
        var src = host.getAttribute('data-pill-matte');
        var video = host.querySelector('video[data-pill-video]');
        var canvas = host.querySelector('canvas[data-pill-canvas]');
        var fallback = host.querySelector('[data-pill-fallback]');
        if (!src || !video || !canvas) return;
        /* one <video>, repointed: the WebM it was going to load cannot render
           here anyway, so nothing is downloaded twice */
        var s = video.querySelector('source');
        if (s) s.parentNode.removeChild(s);
        video.src = src;
        video.load();
        video.addEventListener('loadeddata', function () {
          /* Swap FIRST, then start. start() observes the canvas to park its rAF
             loop off screen, and a display:none element has no box — so an
             observer attached before the swap reports "not intersecting" and the
             loop pauses the video it was meant to be driving. */
          /* NOT display:none — iOS will not play a video it is not rendering,
             and a starved video means an empty canvas. Shrink it to a pixel
             instead so the platform still considers it on screen. */
          video.classList.add('zd-media--driver');
          canvas.style.display = 'block';
          if (fallback) fallback.style.display = 'none';
          if (!start(video, canvas, host)) {
            /* no WebGL: the still image beats an empty canvas */
            canvas.style.display = 'none';
            video.classList.remove('zd-media--driver');
            video.style.display = 'none';
            if (fallback) fallback.style.display = 'block';
          }
        }, { once: true });
        video.addEventListener('error', function () {
          if (fallback) { video.style.display = 'none'; fallback.style.display = 'block'; }
        }, { once: true });
        var p = video.play(); if (p && p.catch) p.catch(function () { });
      })(hosts[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
